var map = {
	"./TRM": 1029,
	"./TRM.js": 1029,
	"./TRM/filter": 171,
	"./TRM/filter.js": 171,
	"./TRM/table": 172,
	"./TRM/table.js": 172,
	"./accounting/accounts": 1030,
	"./accounting/accounts.js": 1030,
	"./accounting/accounts/filter": 173,
	"./accounting/accounts/filter.js": 173,
	"./accounting/accounts/table": 174,
	"./accounting/accounts/table.js": 174,
	"./accounting/area": 1031,
	"./accounting/area.js": 1031,
	"./accounting/area/filter": 986,
	"./accounting/area/filter.js": 986,
	"./accounting/area/table": 175,
	"./accounting/area/table.js": 175,
	"./accounting/area_copy": 1032,
	"./accounting/area_copy.js": 1032,
	"./accounting/closingDayReport": 1033,
	"./accounting/closingDayReport.js": 1033,
	"./accounting/closingDayReport/filter": 176,
	"./accounting/closingDayReport/filter.js": 176,
	"./accounting/closingDayReport/table": 177,
	"./accounting/closingDayReport/table.js": 177,
	"./accounting/concepts": 1034,
	"./accounting/concepts.js": 1034,
	"./accounting/concepts/filter": 178,
	"./accounting/concepts/filter.js": 178,
	"./accounting/concepts/table": 179,
	"./accounting/concepts/table.js": 179,
	"./accounting/costCenter": 1035,
	"./accounting/costCenter.js": 1035,
	"./accounting/costCenter/filter": 180,
	"./accounting/costCenter/filter.js": 180,
	"./accounting/costCenter/table": 181,
	"./accounting/costCenter/table.js": 181,
	"./accounting/employees": 1036,
	"./accounting/employees.js": 1036,
	"./accounting/employees/filter": 987,
	"./accounting/employees/filter.js": 987,
	"./accounting/employees/table": 182,
	"./accounting/employees/table.js": 182,
	"./accounting/expenses": 1037,
	"./accounting/expenses.js": 1037,
	"./accounting/expenses/filter": 183,
	"./accounting/expenses/filter.js": 183,
	"./accounting/expenses/table": 184,
	"./accounting/expenses/table.js": 184,
	"./accounting/incomes": 1038,
	"./accounting/incomes.js": 1038,
	"./accounting/incomes/filter": 185,
	"./accounting/incomes/filter.js": 185,
	"./accounting/incomes/table": 186,
	"./accounting/incomes/table.js": 186,
	"./accounting/position": 1039,
	"./accounting/position.js": 1039,
	"./accounting/position/filter": 988,
	"./accounting/position/filter.js": 988,
	"./accounting/position/table": 187,
	"./accounting/position/table.js": 187,
	"./accounting/productsThirdBetShop": 1040,
	"./accounting/productsThirdBetShop.js": 1040,
	"./accounting/productsThirdBetShop/filter": 989,
	"./accounting/productsThirdBetShop/filter.js": 989,
	"./accounting/productsThirdBetShop/table": 188,
	"./accounting/productsThirdBetShop/table.js": 188,
	"./accounting/productsThirdByBetShop": 1041,
	"./accounting/productsThirdByBetShop.js": 1041,
	"./accounting/productsThirdByBetShop/filter": 189,
	"./accounting/productsThirdByBetShop/filter.js": 189,
	"./accounting/productsThirdByBetShop/table": 190,
	"./accounting/productsThirdByBetShop/table.js": 190,
	"./accounting/productsThirdQuota": 1042,
	"./accounting/productsThirdQuota.js": 1042,
	"./accounting/productsThirdQuota/filter": 191,
	"./accounting/productsThirdQuota/filter.js": 191,
	"./accounting/productsThirdQuota/table": 192,
	"./accounting/productsThirdQuota/table.js": 192,
	"./accounting/providers": 1043,
	"./accounting/providers.js": 1043,
	"./accounting/providers/filter": 990,
	"./accounting/providers/filter.js": 990,
	"./accounting/providers/table": 193,
	"./accounting/providers/table.js": 193,
	"./accounting/providers/tableProductsThirdBetShop": 1044,
	"./accounting/providers/tableProductsThirdBetShop.js": 1044,
	"./accounting/providers_copy": 1045,
	"./accounting/providers_copy.js": 1045,
	"./accounting/squareDayReport": 1046,
	"./accounting/squareDayReport.js": 1046,
	"./accounting/squareDayReport/filter": 194,
	"./accounting/squareDayReport/filter.js": 194,
	"./accounting/squareDayReport/table": 195,
	"./accounting/squareDayReport/table.js": 195,
	"./accounting/squareDayReport2": 1047,
	"./accounting/squareDayReport2.js": 1047,
	"./accounting/squareDayReport2/filter": 196,
	"./accounting/squareDayReport2/filter.js": 196,
	"./accounting/squareDayReport2/table": 197,
	"./accounting/squareDayReport2/table.js": 197,
	"./accounting/typeCenterPosition": 1048,
	"./accounting/typeCenterPosition.js": 1048,
	"./accounting/typeDocument": 1049,
	"./accounting/typeDocument.js": 1049,
	"./accounting/typeDocument/filter": 199,
	"./accounting/typeDocument/filter.js": 199,
	"./accounting/typeDocument/table": 200,
	"./accounting/typeDocument/table.js": 200,
	"./accounting/types/filter": 991,
	"./accounting/types/filter.js": 991,
	"./accounting/types/table": 198,
	"./accounting/types/table.js": 198,
	"./activateRegistration": 1050,
	"./activateRegistration.js": 1050,
	"./addAdminUserManagement": 1051,
	"./addAdminUserManagement.js": 1051,
	"./addAgentListManagement": 1052,
	"./addAgentListManagement.js": 1052,
	"./addBetShopManagement": 1053,
	"./addBetShopManagement.js": 1053,
	"./adminUser": 1054,
	"./adminUser.js": 1054,
	"./adminUserManagement": 1055,
	"./adminUserManagement.js": 1055,
	"./affiliatesBetShop": 1056,
	"./affiliatesBetShop.js": 1056,
	"./agent/addInformationAgentList": 1057,
	"./agent/addInformationAgentList.js": 1057,
	"./agent/age": 1058,
	"./agent/age.js": 1058,
	"./agent/agent-list/detailsAgentList": 207,
	"./agent/agent-list/detailsAgentList.js": 207,
	"./agent/agent-list/filterAgentList": 208,
	"./agent/agent-list/filterAgentList.js": 208,
	"./agent/agent-list/recordAgentList": 209,
	"./agent/agent-list/recordAgentList.js": 209,
	"./agent/agent-list/recordTableAgentList": 992,
	"./agent/agent-list/recordTableAgentList.js": 992,
	"./agent/agent-list/tableAgentList": 210,
	"./agent/agent-list/tableAgentList.js": 210,
	"./agent/agent-retraction/PagoPremio": 211,
	"./agent/agent-retraction/PagoPremio.js": 211,
	"./agent/agent-retraction/search": 212,
	"./agent/agent-retraction/search.js": 212,
	"./agent/agent-retraction/transfers": 213,
	"./agent/agent-retraction/transfers.js": 213,
	"./agent/agent-retraction/transfers1": 214,
	"./agent/agent-retraction/transfers1.js": 214,
	"./agent/agent-transfers/PagoPremio": 215,
	"./agent/agent-transfers/PagoPremio.js": 215,
	"./agent/agent-transfers/search": 216,
	"./agent/agent-transfers/search.js": 216,
	"./agent/agent-transfers/transfers": 217,
	"./agent/agent-transfers/transfers.js": 217,
	"./agent/agent-transfers/transfers1": 218,
	"./agent/agent-transfers/transfers1.js": 218,
	"./agent/agent-tree/details": 993,
	"./agent/agent-tree/details.js": 993,
	"./agent/agent-tree/filter": 219,
	"./agent/agent-tree/filter.js": 219,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 220,
	"./agent/agent-tree/recordTableAgentList.js": 220,
	"./agent/agent-tree/table": 221,
	"./agent/agent-tree/table.js": 221,
	"./agent/bonusReportAgentList": 1059,
	"./agent/bonusReportAgentList.js": 1059,
	"./agent/casinoGamesReportAgentList": 1060,
	"./agent/casinoGamesReportAgentList.js": 1060,
	"./agent/comissions": 1061,
	"./agent/comissions.js": 1061,
	"./agent/comissions/autoexclusionUsers": 1062,
	"./agent/comissions/autoexclusionUsers.js": 1062,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1063,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1063,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1064,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1064,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1065,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1065,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1066,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1066,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1067,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1067,
	"./agent/comissions/betsReport/detailsReport": 1068,
	"./agent/comissions/betsReport/detailsReport.js": 1068,
	"./agent/comissions/betsReport/filterReport": 1069,
	"./agent/comissions/betsReport/filterReport.js": 1069,
	"./agent/comissions/betsReport/recordReport": 1070,
	"./agent/comissions/betsReport/recordReport.js": 1070,
	"./agent/comissions/betsReport/recordTableReport": 1071,
	"./agent/comissions/betsReport/recordTableReport.js": 1071,
	"./agent/comissions/betsReport/recordTableTransReport": 1072,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1072,
	"./agent/comissions/betsReport/recordTransReport": 1073,
	"./agent/comissions/betsReport/recordTransReport.js": 1073,
	"./agent/comissions/betsReport/tableReport": 1074,
	"./agent/comissions/betsReport/tableReport.js": 1074,
	"./agent/comissions/betsReportBetShop": 1075,
	"./agent/comissions/betsReportBetShop.js": 1075,
	"./agent/comissions/bonusReport/detailsBonusReport": 1076,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1076,
	"./agent/comissions/bonusReport/filterBonusReport": 1077,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1077,
	"./agent/comissions/bonusReport/recordBonusReport": 1078,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1078,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1079,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1079,
	"./agent/comissions/bonusReport/tableBonusReport": 1080,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1080,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1081,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1081,
	"./agent/comissions/casinoReport/filterCasinoReport": 1082,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1082,
	"./agent/comissions/casinoReport/recordCasinoReport": 1083,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1083,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1084,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1084,
	"./agent/comissions/casinoReport/tableCasinoReport": 1085,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1085,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1086,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1086,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1087,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1087,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1088,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1088,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1089,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1089,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1090,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1090,
	"./agent/comissions/comissions": 1091,
	"./agent/comissions/comissions.js": 1091,
	"./agent/comissions/comissions/table": 230,
	"./agent/comissions/comissions/table.js": 230,
	"./agent/comissions/comissionsReportBetShop": 1092,
	"./agent/comissions/comissionsReportBetShop.js": 1092,
	"./agent/comissions/comissionsReportBetShopDetail": 1093,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1093,
	"./agent/comissions/comissions_report/detailsDepositReports": 1094,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1094,
	"./agent/comissions/comissions_report/filter": 231,
	"./agent/comissions/comissions_report/filter.js": 231,
	"./agent/comissions/comissions_report/recordDepositReports": 1095,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1095,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1096,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1096,
	"./agent/comissions/comissions_report/table": 232,
	"./agent/comissions/comissions_report/table.js": 232,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1097,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1097,
	"./agent/comissions/comissions_report_detail/filter": 233,
	"./agent/comissions/comissions_report_detail/filter.js": 233,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1098,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1098,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1099,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1099,
	"./agent/comissions/comissions_report_detail/table": 234,
	"./agent/comissions/comissions_report_detail/table.js": 234,
	"./agent/comissions/expenses": 1100,
	"./agent/comissions/expenses.js": 1100,
	"./agent/comissions/expenses/filter": 1101,
	"./agent/comissions/expenses/filter.js": 1101,
	"./agent/comissions/expenses/table": 1102,
	"./agent/comissions/expenses/table.js": 1102,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1103,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1103,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1104,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1104,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1105,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1105,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1106,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1106,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1107,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1107,
	"./agent/comissions/incomes": 1108,
	"./agent/comissions/incomes.js": 1108,
	"./agent/comissions/incomes/filter": 1109,
	"./agent/comissions/incomes/filter.js": 1109,
	"./agent/comissions/incomes/table": 1110,
	"./agent/comissions/incomes/table.js": 1110,
	"./agent/comissions/productsThird": 1111,
	"./agent/comissions/productsThird.js": 1111,
	"./agent/comissions/productsThird/filter": 1112,
	"./agent/comissions/productsThird/filter.js": 1112,
	"./agent/comissions/productsThird/table": 1113,
	"./agent/comissions/productsThird/table.js": 1113,
	"./agent/comissions/promotionalCodes": 1114,
	"./agent/comissions/promotionalCodes.js": 1114,
	"./agent/comissions/promotionalCodes/filter": 1115,
	"./agent/comissions/promotionalCodes/filter.js": 1115,
	"./agent/comissions/promotionalCodes/table": 1116,
	"./agent/comissions/promotionalCodes/table.js": 1116,
	"./agent/comissions/withdrawalRequests": 1117,
	"./agent/comissions/withdrawalRequests.js": 1117,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 237,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 237,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 235,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 235,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1118,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1118,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 238,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 238,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 236,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 236,
	"./agent/configuration/changePassword": 1119,
	"./agent/configuration/changePassword.js": 1119,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1120,
	"./agent/configuration/generateToken.js": 1120,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1121,
	"./agent/configuration/qrgoogle.js": 1121,
	"./agent/configuration/securityChanges": 1122,
	"./agent/configuration/securityChanges.js": 1122,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1123,
	"./agent/configurationAgentList.js": 1123,
	"./agent/depositReportAgentList": 1124,
	"./agent/depositReportAgentList.js": 1124,
	"./agent/financescustomerAgentList": 1125,
	"./agent/financescustomerAgentList.js": 1125,
	"./agent/financial/comisiones": 1126,
	"./agent/financial/comisiones.js": 1126,
	"./agent/financial/comisiones/table": 241,
	"./agent/financial/comisiones/table.js": 241,
	"./agent/financial/informationFinancialAgentList": 1127,
	"./agent/financial/informationFinancialAgentList.js": 1127,
	"./agent/financial/withdrawalRequestsAgentList": 1128,
	"./agent/financial/withdrawalRequestsAgentList.js": 1128,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 242,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 242,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1129,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1129,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 243,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 243,
	"./agent/flujoCajaAgentList": 1130,
	"./agent/flujoCajaAgentList.js": 1130,
	"./agent/flujoCajaHijosAgentList": 1131,
	"./agent/flujoCajaHijosAgentList.js": 1131,
	"./agent/geo": 1132,
	"./agent/geo.js": 1132,
	"./agent/informationAgentList": 1133,
	"./agent/informationAgentList.js": 1133,
	"./agent/informeRed/details": 1134,
	"./agent/informeRed/details.js": 1134,
	"./agent/informeRed/filter": 250,
	"./agent/informeRed/filter.js": 250,
	"./agent/informeRed/record": 1135,
	"./agent/informeRed/record.js": 1135,
	"./agent/informeRed/recordTable": 1136,
	"./agent/informeRed/recordTable.js": 1136,
	"./agent/informeRed/table": 251,
	"./agent/informeRed/table.js": 251,
	"./agent/money": 1137,
	"./agent/money.js": 1137,
	"./agent/paymenthistory": 1138,
	"./agent/paymenthistory.js": 1138,
	"./agent/positions": 1139,
	"./agent/positions.js": 1139,
	"./agent/reports/autoexclusionUsers": 1140,
	"./agent/reports/autoexclusionUsers.js": 1140,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1141,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1141,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1142,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1142,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1143,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1143,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1144,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1144,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1145,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1145,
	"./agent/reports/balanceTransactionReport": 1146,
	"./agent/reports/balanceTransactionReport.js": 1146,
	"./agent/reports/balanceTransactionReport/filter": 252,
	"./agent/reports/balanceTransactionReport/filter.js": 252,
	"./agent/reports/balanceTransactionReport/table": 253,
	"./agent/reports/balanceTransactionReport/table.js": 253,
	"./agent/reports/betsReport/detailsReport": 1147,
	"./agent/reports/betsReport/detailsReport.js": 1147,
	"./agent/reports/betsReport/filterReport": 254,
	"./agent/reports/betsReport/filterReport.js": 254,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1148,
	"./agent/reports/betsReport/recordTableReport.js": 1148,
	"./agent/reports/betsReport/recordTableTransReport": 1149,
	"./agent/reports/betsReport/recordTableTransReport.js": 1149,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 255,
	"./agent/reports/betsReport/tableReport.js": 255,
	"./agent/reports/betsReportAgentList": 1150,
	"./agent/reports/betsReportAgentList.js": 1150,
	"./agent/reports/bonusReport/detailsBonusReport": 224,
	"./agent/reports/bonusReport/detailsBonusReport.js": 224,
	"./agent/reports/bonusReport/filterBonusReport": 222,
	"./agent/reports/bonusReport/filterBonusReport.js": 222,
	"./agent/reports/bonusReport/recordBonusReport": 225,
	"./agent/reports/bonusReport/recordBonusReport.js": 225,
	"./agent/reports/bonusReport/recordTableBonusReport": 1151,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1151,
	"./agent/reports/bonusReport/tableBonusReport": 223,
	"./agent/reports/bonusReport/tableBonusReport.js": 223,
	"./agent/reports/casinoReport/detailsCasinoReport": 228,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 228,
	"./agent/reports/casinoReport/filterCasinoReport": 226,
	"./agent/reports/casinoReport/filterCasinoReport.js": 226,
	"./agent/reports/casinoReport/recordCasinoReport": 229,
	"./agent/reports/casinoReport/recordCasinoReport.js": 229,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1152,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1152,
	"./agent/reports/casinoReport/tableCasinoReport": 227,
	"./agent/reports/casinoReport/tableCasinoReport.js": 227,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1153,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1153,
	"./agent/reports/casinoReport2/filterCasinoReport": 1154,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1154,
	"./agent/reports/casinoReport2/recordCasinoReport": 1155,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1155,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1156,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1156,
	"./agent/reports/casinoReport2/tableCasinoReport": 1157,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1157,
	"./agent/reports/deposit_report/detailsDepositReports": 1158,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1158,
	"./agent/reports/deposit_report/filterDepositReports": 239,
	"./agent/reports/deposit_report/filterDepositReports.js": 239,
	"./agent/reports/deposit_report/recordDepositReports": 1159,
	"./agent/reports/deposit_report/recordDepositReports.js": 1159,
	"./agent/reports/deposit_report/recordTableDepositReports": 1160,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1160,
	"./agent/reports/deposit_report/tableDepositReports": 240,
	"./agent/reports/deposit_report/tableDepositReports.js": 240,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1161,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1161,
	"./agent/reports/flujocaja/filterFlujoCaja": 244,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 244,
	"./agent/reports/flujocaja/recordFlujoCaja": 1162,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1162,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1163,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1163,
	"./agent/reports/flujocaja/tableFlujoCaja": 245,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 245,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 248,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 248,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 246,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 246,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 249,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 249,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1164,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1164,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 247,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 247,
	"./agent/reports/managementReport": 1165,
	"./agent/reports/managementReport.js": 1165,
	"./agent/reports/managementReport/filterReports": 256,
	"./agent/reports/managementReport/filterReports.js": 256,
	"./agent/reports/managementReport/tableReports": 257,
	"./agent/reports/managementReport/tableReports.js": 257,
	"./agent/reports/marketing/filterReports": 258,
	"./agent/reports/marketing/filterReports.js": 258,
	"./agent/reports/marketing/tableReports": 259,
	"./agent/reports/marketing/tableReports.js": 259,
	"./agent/reports/marketingReport": 1166,
	"./agent/reports/marketingReport.js": 1166,
	"./agent/reports/promotionalCodes": 1167,
	"./agent/reports/promotionalCodes.js": 1167,
	"./agent/reports/promotionalCodes/filter": 260,
	"./agent/reports/promotionalCodes/filter.js": 260,
	"./agent/reports/promotionalCodes/table": 261,
	"./agent/reports/promotionalCodes/table.js": 261,
	"./agent/reports/quotaRetractionReport/filter": 262,
	"./agent/reports/quotaRetractionReport/filter.js": 262,
	"./agent/reports/quotaRetractionReport/table": 263,
	"./agent/reports/quotaRetractionReport/table.js": 263,
	"./agent/reports/quotaRetractionReportAgent": 1168,
	"./agent/reports/quotaRetractionReportAgent.js": 1168,
	"./agent/reports/transfersReport/filter": 264,
	"./agent/reports/transfersReport/filter.js": 264,
	"./agent/reports/transfersReport/table": 265,
	"./agent/reports/transfersReport/table.js": 265,
	"./agent/reports/trasnfersReport": 1169,
	"./agent/reports/trasnfersReport.js": 1169,
	"./agent/reports/userAfilliatesReport": 1170,
	"./agent/reports/userAfilliatesReport.js": 1170,
	"./agent/reports/user_affiliates/detailsReports": 268,
	"./agent/reports/user_affiliates/detailsReports.js": 268,
	"./agent/reports/user_affiliates/filterReports": 266,
	"./agent/reports/user_affiliates/filterReports.js": 266,
	"./agent/reports/user_affiliates/recordReports": 269,
	"./agent/reports/user_affiliates/recordReports.js": 269,
	"./agent/reports/user_affiliates/recordTableReports": 1171,
	"./agent/reports/user_affiliates/recordTableReports.js": 1171,
	"./agent/reports/user_affiliates/tableReports": 267,
	"./agent/reports/user_affiliates/tableReports.js": 267,
	"./agent/reportscustomerAgentList": 1172,
	"./agent/reportscustomerAgentList.js": 1172,
	"./agent/requestsAgent": 1173,
	"./agent/requestsAgent.js": 1173,
	"./agent/requestsAgent/filter": 270,
	"./agent/requestsAgent/filter.js": 270,
	"./agent/requestsAgent/table": 271,
	"./agent/requestsAgent/table.js": 271,
	"./agent/requirementsAgent": 1174,
	"./agent/requirementsAgent.js": 1174,
	"./agent/requirementsAgent/details": 274,
	"./agent/requirementsAgent/details.js": 274,
	"./agent/requirementsAgent/detailsFilter": 276,
	"./agent/requirementsAgent/detailsFilter.js": 276,
	"./agent/requirementsAgent/detailsTable": 275,
	"./agent/requirementsAgent/detailsTable.js": 275,
	"./agent/requirementsAgent/filter": 272,
	"./agent/requirementsAgent/filter.js": 272,
	"./agent/requirementsAgent/table": 273,
	"./agent/requirementsAgent/table.js": 273,
	"./agent/statistics/age": 277,
	"./agent/statistics/age.js": 277,
	"./agent/statistics/marketing": 278,
	"./agent/statistics/marketing.js": 278,
	"./agent/statistics/marketingvsregistros": 279,
	"./agent/statistics/marketingvsregistros.js": 279,
	"./agent/statistics/money": 280,
	"./agent/statistics/money.js": 280,
	"./agent/statisticsAgentList": 1175,
	"./agent/statisticsAgentList.js": 1175,
	"./agent/tags": 1176,
	"./agent/tags.js": 1176,
	"./agentList": 1177,
	"./agentList.js": 1177,
	"./agentListManagement": 1178,
	"./agentListManagement.js": 1178,
	"./agentRetraction": 1179,
	"./agentRetraction.js": 1179,
	"./agentTransfers": 1180,
	"./agentTransfers.js": 1180,
	"./agentsInform": 1181,
	"./agentsInform.js": 1181,
	"./agentsTree": 1182,
	"./agentsTree.js": 1182,
	"./alltactions": 281,
	"./alltactions.js": 281,
	"./approvalLogs": 1183,
	"./approvalLogs.js": 1183,
	"./approvalLogs2": 1184,
	"./approvalLogs2.js": 1184,
	"./approvalLogsBetShop": 1185,
	"./approvalLogsBetShop.js": 1185,
	"./assignmentQuotaMade": 1186,
	"./assignmentQuotaMade.js": 1186,
	"./assignmentQuotaR": 1187,
	"./assignmentQuotaR.js": 1187,
	"./autoexclusionUsers": 1188,
	"./autoexclusionUsers.js": 1188,
	"./balanceAdjustments": 1189,
	"./balanceAdjustments.js": 1189,
	"./balanceHistory": 1190,
	"./balanceHistory.js": 1190,
	"./balanceHistory2": 1191,
	"./balanceHistory2.js": 1191,
	"./balanceHistoryAdminUser": 1192,
	"./balanceHistoryAdminUser.js": 1192,
	"./balanceHistoryBetShop": 1193,
	"./balanceHistoryBetShop.js": 1193,
	"./balanceHistoryBetShop2": 1194,
	"./balanceHistoryBetShop2.js": 1194,
	"./balanceHistoryForAgent": 1195,
	"./balanceHistoryForAgent.js": 1195,
	"./balanceHistoryForBetShop": 1196,
	"./balanceHistoryForBetShop.js": 1196,
	"./balanceHistoryMachine": 1197,
	"./balanceHistoryMachine.js": 1197,
	"./balanceUsers": 1198,
	"./balanceUsers.js": 1198,
	"./bankAccounts": 1199,
	"./bankAccounts.js": 1199,
	"./banks": 1200,
	"./banks.js": 1200,
	"./betShop": 1201,
	"./betShop.js": 1201,
	"./betShopCompetence": 1202,
	"./betShopCompetence.js": 1202,
	"./betShopManagement": 1203,
	"./betShopManagement.js": 1203,
	"./betShopManagement/addInformationBetShop": 1204,
	"./betShopManagement/addInformationBetShop.js": 1204,
	"./betShopManagement/age": 1205,
	"./betShopManagement/age.js": 1205,
	"./betShopManagement/betShop/detailsBetShop": 994,
	"./betShopManagement/betShop/detailsBetShop.js": 994,
	"./betShopManagement/betShop/filterBetShop": 322,
	"./betShopManagement/betShop/filterBetShop.js": 322,
	"./betShopManagement/betShop/recordBetShop": 324,
	"./betShopManagement/betShop/recordBetShop.js": 324,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 323,
	"./betShopManagement/betShop/tableBetShop.js": 323,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1206,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1206,
	"./betShopManagement/betShopCompetence/filterBetShop": 325,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 325,
	"./betShopManagement/betShopCompetence/recordBetShop": 1207,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1207,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1208,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1208,
	"./betShopManagement/betShopCompetence/tableBetShop": 326,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 326,
	"./betShopManagement/bonusReportBetShop": 1209,
	"./betShopManagement/bonusReportBetShop.js": 1209,
	"./betShopManagement/cashier/betShopAdvertising": 331,
	"./betShopManagement/cashier/betShopAdvertising.js": 331,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 333,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 333,
	"./betShopManagement/cashier/betShopCashier": 1210,
	"./betShopManagement/cashier/betShopCashier.js": 1210,
	"./betShopManagement/cashier/betShopComissions": 995,
	"./betShopManagement/cashier/betShopComissions.js": 995,
	"./betShopManagement/cashier/filterCashier": 336,
	"./betShopManagement/cashier/filterCashier.js": 336,
	"./betShopManagement/cashier/tableAdvertising": 332,
	"./betShopManagement/cashier/tableAdvertising.js": 332,
	"./betShopManagement/cashier/tableAdvertisingCashier": 334,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 334,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 335,
	"./betShopManagement/cashier/tableComissions.js": 335,
	"./betShopManagement/casinoGamesReportBetShop": 1211,
	"./betShopManagement/casinoGamesReportBetShop.js": 1211,
	"./betShopManagement/comissions": 1212,
	"./betShopManagement/comissions.js": 1212,
	"./betShopManagement/comissions/autoexclusionUsers": 1213,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1213,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1214,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1214,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1215,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1215,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1216,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1216,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1217,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1217,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1218,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1218,
	"./betShopManagement/comissions/betsReport/detailsReport": 1219,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1219,
	"./betShopManagement/comissions/betsReport/filterReport": 1220,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1220,
	"./betShopManagement/comissions/betsReport/recordReport": 1221,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1221,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1222,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1222,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1223,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1223,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1224,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1224,
	"./betShopManagement/comissions/betsReport/tableReport": 1225,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1225,
	"./betShopManagement/comissions/betsReportBetShop": 1226,
	"./betShopManagement/comissions/betsReportBetShop.js": 1226,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1227,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1227,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1228,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1228,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1229,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1229,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1230,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1230,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1231,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1231,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1232,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1232,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1233,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1233,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1234,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1234,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1235,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1235,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1236,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1236,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1237,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1237,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1238,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1238,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1239,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1239,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1240,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1240,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1241,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1241,
	"./betShopManagement/comissions/comissions": 1242,
	"./betShopManagement/comissions/comissions.js": 1242,
	"./betShopManagement/comissions/comissions/table": 341,
	"./betShopManagement/comissions/comissions/table.js": 341,
	"./betShopManagement/comissions/comissionsReportBetShop": 1243,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1243,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1244,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1244,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1245,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1245,
	"./betShopManagement/comissions/comissions_report/filter": 342,
	"./betShopManagement/comissions/comissions_report/filter.js": 342,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1246,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1246,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1247,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1247,
	"./betShopManagement/comissions/comissions_report/table": 343,
	"./betShopManagement/comissions/comissions_report/table.js": 343,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1248,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1248,
	"./betShopManagement/comissions/comissions_report_detail/filter": 344,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 344,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1249,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1249,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1250,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1250,
	"./betShopManagement/comissions/comissions_report_detail/table": 345,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 345,
	"./betShopManagement/comissions/expenses": 1251,
	"./betShopManagement/comissions/expenses.js": 1251,
	"./betShopManagement/comissions/expenses/filter": 1252,
	"./betShopManagement/comissions/expenses/filter.js": 1252,
	"./betShopManagement/comissions/expenses/table": 1253,
	"./betShopManagement/comissions/expenses/table.js": 1253,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1254,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1254,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1255,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1255,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1256,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1256,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1257,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1257,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1258,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1258,
	"./betShopManagement/comissions/incomes": 1259,
	"./betShopManagement/comissions/incomes.js": 1259,
	"./betShopManagement/comissions/incomes/filter": 1260,
	"./betShopManagement/comissions/incomes/filter.js": 1260,
	"./betShopManagement/comissions/incomes/table": 1261,
	"./betShopManagement/comissions/incomes/table.js": 1261,
	"./betShopManagement/comissions/productsThird": 1262,
	"./betShopManagement/comissions/productsThird.js": 1262,
	"./betShopManagement/comissions/productsThird/filter": 1263,
	"./betShopManagement/comissions/productsThird/filter.js": 1263,
	"./betShopManagement/comissions/productsThird/table": 1264,
	"./betShopManagement/comissions/productsThird/table.js": 1264,
	"./betShopManagement/comissions/promotionalCodes": 1265,
	"./betShopManagement/comissions/promotionalCodes.js": 1265,
	"./betShopManagement/comissions/promotionalCodes/filter": 1266,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1266,
	"./betShopManagement/comissions/promotionalCodes/table": 1267,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1267,
	"./betShopManagement/comissions/withdrawalRequests": 1268,
	"./betShopManagement/comissions/withdrawalRequests.js": 1268,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 348,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 348,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 346,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 346,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1269,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1269,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 349,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 349,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 347,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 347,
	"./betShopManagement/configuration/changePassword": 1270,
	"./betShopManagement/configuration/changePassword.js": 1270,
	"./betShopManagement/configuration/changePassword/changePasswordView": 350,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 350,
	"./betShopManagement/configuration/generateToken": 1271,
	"./betShopManagement/configuration/generateToken.js": 1271,
	"./betShopManagement/configuration/generateToken/filter": 351,
	"./betShopManagement/configuration/generateToken/filter.js": 351,
	"./betShopManagement/configuration/generateToken/table": 352,
	"./betShopManagement/configuration/generateToken/table.js": 352,
	"./betShopManagement/configuration/qrgoogle": 1272,
	"./betShopManagement/configuration/qrgoogle.js": 1272,
	"./betShopManagement/configuration/securityChanges": 1273,
	"./betShopManagement/configuration/securityChanges.js": 1273,
	"./betShopManagement/configuration/securityChanges/filter": 996,
	"./betShopManagement/configuration/securityChanges/filter.js": 996,
	"./betShopManagement/configuration/securityChanges/table": 353,
	"./betShopManagement/configuration/securityChanges/table.js": 353,
	"./betShopManagement/configurationBetShop": 1274,
	"./betShopManagement/configurationBetShop.js": 1274,
	"./betShopManagement/depositReportBetShop": 1275,
	"./betShopManagement/depositReportBetShop.js": 1275,
	"./betShopManagement/financescustomerBetShop": 1276,
	"./betShopManagement/financescustomerBetShop.js": 1276,
	"./betShopManagement/financial/bankAccountsBetShop": 1277,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1277,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1278,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1278,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 356,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 356,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1279,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1279,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1280,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1280,
	"./betShopManagement/financial/bankAccountsBetShop/table": 357,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 357,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1281,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1281,
	"./betShopManagement/financial/informationFinancialBetShop": 1282,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1282,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1283,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1283,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 358,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 358,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 360,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 360,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 359,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 359,
	"./betShopManagement/flujoCajaBetShop": 1284,
	"./betShopManagement/flujoCajaBetShop.js": 1284,
	"./betShopManagement/geo": 1285,
	"./betShopManagement/geo.js": 1285,
	"./betShopManagement/informationBetShop": 1286,
	"./betShopManagement/informationBetShop.js": 1286,
	"./betShopManagement/money": 1287,
	"./betShopManagement/money.js": 1287,
	"./betShopManagement/paymenthistory": 1288,
	"./betShopManagement/paymenthistory.js": 1288,
	"./betShopManagement/positions": 1289,
	"./betShopManagement/positions.js": 1289,
	"./betShopManagement/reports/autoexclusionUsers": 1290,
	"./betShopManagement/reports/autoexclusionUsers.js": 1290,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1291,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1291,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1292,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1292,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1293,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1293,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1294,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1294,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1295,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1295,
	"./betShopManagement/reports/balanceTransactionReport": 1296,
	"./betShopManagement/reports/balanceTransactionReport.js": 1296,
	"./betShopManagement/reports/balanceTransactionReport/filter": 363,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 363,
	"./betShopManagement/reports/balanceTransactionReport/table": 364,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 364,
	"./betShopManagement/reports/betsReport/detailsReport": 1297,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1297,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1298,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1298,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1299,
	"./betShopManagement/reports/betsReportBetShop.js": 1299,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 329,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 329,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 327,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 327,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 330,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 330,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1300,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1300,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 328,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 328,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 339,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 339,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 337,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 337,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 340,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 340,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1301,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1301,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 338,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 338,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1302,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1302,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1303,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1303,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1304,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1304,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1305,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1305,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1306,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1306,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 997,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 997,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 354,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 354,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1307,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1307,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 355,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 355,
	"./betShopManagement/reports/expenses": 1308,
	"./betShopManagement/reports/expenses.js": 1308,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1309,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1309,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 361,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 361,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1310,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1310,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1311,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1311,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 362,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 362,
	"./betShopManagement/reports/historyMovement": 1312,
	"./betShopManagement/reports/historyMovement.js": 1312,
	"./betShopManagement/reports/historyMovement/filter": 365,
	"./betShopManagement/reports/historyMovement/filter.js": 365,
	"./betShopManagement/reports/historyMovement/table": 366,
	"./betShopManagement/reports/historyMovement/table.js": 366,
	"./betShopManagement/reports/incomes": 1313,
	"./betShopManagement/reports/incomes.js": 1313,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1314,
	"./betShopManagement/reports/productsThird.js": 1314,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1315,
	"./betShopManagement/reports/promotionalCodes.js": 1315,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1316,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1316,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 367,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 367,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 368,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 368,
	"./betShopManagement/reportscustomerBetShop": 1317,
	"./betShopManagement/reportscustomerBetShop.js": 1317,
	"./betShopManagement/statisticsBetShop": 1318,
	"./betShopManagement/statisticsBetShop.js": 1318,
	"./betShopManagement/tags": 1319,
	"./betShopManagement/tags.js": 1319,
	"./betsHistory": 1320,
	"./betsHistory.js": 1320,
	"./betsHistory2": 1321,
	"./betsHistory2.js": 1321,
	"./betsReport": 1322,
	"./betsReport.js": 1322,
	"./betsReportBetShop": 1323,
	"./betsReportBetShop.js": 1323,
	"./betsReportSecond": 1324,
	"./betsReportSecond.js": 1324,
	"./betsSport": 1325,
	"./betsSport.js": 1325,
	"./betsSportLive": 1326,
	"./betsSportLive.js": 1326,
	"./betsVirtual": 1327,
	"./betsVirtual.js": 1327,
	"./betting": 1328,
	"./betting.js": 1328,
	"./bettingVirtual": 1329,
	"./bettingVirtual.js": 1329,
	"./blockchains": 1330,
	"./blockchains.js": 1330,
	"./bonusReport": 1331,
	"./bonusReport.js": 1331,
	"./bonusReport2": 1332,
	"./bonusReport2.js": 1332,
	"./cash/bankAccounts/filter": 317,
	"./cash/bankAccounts/filter.js": 317,
	"./cash/bankAccounts/table": 318,
	"./cash/bankAccounts/table.js": 318,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1333,
	"./cash/bets/betHistory2.js": 1333,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 373,
	"./cash/bets/sportLive.js": 373,
	"./cash/bets/sportVirtual": 374,
	"./cash/bets/sportVirtual.js": 374,
	"./cash/closeBox-edit/creditCards": 381,
	"./cash/closeBox-edit/creditCards.js": 381,
	"./cash/closeBox-edit/otherExpenses": 382,
	"./cash/closeBox-edit/otherExpenses.js": 382,
	"./cash/closeBox-edit/otherIncome": 383,
	"./cash/closeBox-edit/otherIncome.js": 383,
	"./cash/closeBox-edit/products": 384,
	"./cash/closeBox-edit/products.js": 384,
	"./cash/closeBox-edit/total": 385,
	"./cash/closeBox-edit/total.js": 385,
	"./cash/closeBox-old/otherExpenses": 1334,
	"./cash/closeBox-old/otherExpenses.js": 1334,
	"./cash/closeBox-old/otherIncome": 1335,
	"./cash/closeBox-old/otherIncome.js": 1335,
	"./cash/closeBox-old/products": 1336,
	"./cash/closeBox-old/products.js": 1336,
	"./cash/closeBox-old/total": 1337,
	"./cash/closeBox-old/total.js": 1337,
	"./cash/closeBox/creditCards": 386,
	"./cash/closeBox/creditCards.js": 386,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 387,
	"./cash/flujocaja/detailsFlujoCaja.js": 387,
	"./cash/flujocaja/filterFlujoCaja": 388,
	"./cash/flujocaja/filterFlujoCaja.js": 388,
	"./cash/flujocaja/recordFlujoCaja": 389,
	"./cash/flujocaja/recordFlujoCaja.js": 389,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 390,
	"./cash/flujocaja/tableFlujoCaja.js": 390,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 391,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 391,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 392,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 392,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 998,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 998,
	"./cash/pagopremio/PagoPremio": 393,
	"./cash/pagopremio/PagoPremio.js": 393,
	"./cash/pagopremio/detailsPagoPremio": 394,
	"./cash/pagopremio/detailsPagoPremio.js": 394,
	"./cash/pagopremio/filterPagoPremio": 395,
	"./cash/pagopremio/filterPagoPremio.js": 395,
	"./cash/pagopremio/recordPagoPremio": 396,
	"./cash/pagopremio/recordPagoPremio.js": 396,
	"./cash/pagopremio/recordTablePagoPremio": 1338,
	"./cash/pagopremio/recordTablePagoPremio.js": 1338,
	"./cash/pagopremio/tablePagoPremio": 397,
	"./cash/pagopremio/tablePagoPremio.js": 397,
	"./cash/pagopremiovirtuales/PagoPremio": 398,
	"./cash/pagopremiovirtuales/PagoPremio.js": 398,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 399,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 399,
	"./cash/pagopremiovirtuales/filterPagoPremio": 400,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 400,
	"./cash/pagopremiovirtuales/recordPagoPremio": 401,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 401,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1339,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1339,
	"./cash/pagopremiovirtuales/tablePagoPremio": 402,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 402,
	"./cash/payPrizesLoyalty/PagoPremio": 403,
	"./cash/payPrizesLoyalty/PagoPremio.js": 403,
	"./cash/payPrizesLoyalty/filterPagoPremio": 404,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 404,
	"./cash/recargacredito/RecargaCredito": 405,
	"./cash/recargacredito/RecargaCredito.js": 405,
	"./cash/recargacredito/filterRecargaCredito": 406,
	"./cash/recargacredito/filterRecargaCredito.js": 406,
	"./cash/recargacreditoAgent/RecargaCredito": 407,
	"./cash/recargacreditoAgent/RecargaCredito.js": 407,
	"./cash/recargacreditoAgent/filterRecargaCredito": 408,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 408,
	"./cash/withdrawal/filter": 409,
	"./cash/withdrawal/filter.js": 409,
	"./cash/withdrawal/table": 410,
	"./cash/withdrawal/table.js": 410,
	"./cashiers": 1340,
	"./cashiers.js": 1340,
	"./casinoGamesReport": 1341,
	"./casinoGamesReport.js": 1341,
	"./casinoGamesReport2": 1342,
	"./casinoGamesReport2.js": 1342,
	"./categories": 1343,
	"./categories.js": 1343,
	"./categoriesProducts": 1344,
	"./categoriesProducts.js": 1344,
	"./closeBox": 1345,
	"./closeBox-old": 1346,
	"./closeBox-old.js": 1346,
	"./closeBox.js": 1345,
	"./closeBoxEdit": 1347,
	"./closeBoxEdit.js": 1347,
	"./comissionsReport": 1348,
	"./comissionsReport.js": 1348,
	"./comissionsReport2": 1349,
	"./comissionsReport2.js": 1349,
	"./commisionsPay": 1350,
	"./commisionsPay.js": 1350,
	"./competitors/competitors": 1351,
	"./competitors/competitors.js": 1351,
	"./competitors/filter": 427,
	"./competitors/filter.js": 427,
	"./competitors/table": 428,
	"./competitors/table.js": 428,
	"./consolidatedIncomeOwner": 1352,
	"./consolidatedIncomeOwner.js": 1352,
	"./consolidatedIncomeOwner2": 1353,
	"./consolidatedIncomeOwner2.js": 1353,
	"./contingency": 1354,
	"./contingency.js": 1354,
	"./countries": 1355,
	"./countries.js": 1355,
	"./coupons": 1356,
	"./coupons.js": 1356,
	"./couponsReport": 1357,
	"./couponsReport.js": 1357,
	"./cryptoBlockchain": 1358,
	"./cryptoBlockchain.js": 1358,
	"./cryptos": 1359,
	"./cryptos.js": 1359,
	"./customReport": 1360,
	"./customReport.js": 1360,
	"./customers": 1361,
	"./customers.js": 1361,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1362,
	"./customers/bonusReport.js": 1362,
	"./customers/bonusReport2": 1363,
	"./customers/bonusReport2.js": 1363,
	"./customers/casinoGamesReport": 1364,
	"./customers/casinoGamesReport.js": 1364,
	"./customers/configuration": 1365,
	"./customers/configuration.js": 1365,
	"./customers/configuration/changePassword": 1366,
	"./customers/configuration/changePassword.js": 1366,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1367,
	"./customers/configuration/generateToken.js": 1367,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1368,
	"./customers/configuration/limitChanges.js": 1368,
	"./customers/configuration/securityChanges": 1369,
	"./customers/configuration/securityChanges.js": 1369,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1370,
	"./customers/configuration/securityChanges2.js": 1370,
	"./customers/depositReport": 1371,
	"./customers/depositReport.js": 1371,
	"./customers/financescustomer": 1372,
	"./customers/financescustomer.js": 1372,
	"./customers/financial/bankAccounts": 1373,
	"./customers/financial/bankAccounts.js": 1373,
	"./customers/financial/bankAccounts/details": 1003,
	"./customers/financial/bankAccounts/details.js": 1003,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 448,
	"./customers/financial/bankAccounts/record.js": 448,
	"./customers/financial/bankAccounts/recordTable": 1374,
	"./customers/financial/bankAccounts/recordTable.js": 1374,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1375,
	"./customers/financial/bankAccounts/tablePopup.js": 1375,
	"./customers/financial/informationFinancial": 1376,
	"./customers/financial/informationFinancial.js": 1376,
	"./customers/financial/withdrawalRequests": 1377,
	"./customers/financial/withdrawalRequests.js": 1377,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1378,
	"./customers/information.js": 1378,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 449,
	"./customers/paymenthistory.js": 449,
	"./customers/players/filter": 450,
	"./customers/players/filter.js": 450,
	"./customers/players/table": 451,
	"./customers/players/table.js": 451,
	"./customers/players2/filter": 452,
	"./customers/players2/filter.js": 452,
	"./customers/players2/table": 453,
	"./customers/players2/table.js": 453,
	"./customers/playersAggregator/filter": 454,
	"./customers/playersAggregator/filter.js": 454,
	"./customers/playersAggregator/table": 455,
	"./customers/playersAggregator/table.js": 455,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1379,
	"./customers/referralsReport.js": 1379,
	"./customers/reports/autoexclusionUsers": 1380,
	"./customers/reports/autoexclusionUsers.js": 1380,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1381,
	"./customers/reports/balanceAdjustments.js": 1381,
	"./customers/reports/balanceAdjustments/filter": 458,
	"./customers/reports/balanceAdjustments/filter.js": 458,
	"./customers/reports/balanceAdjustments/table": 459,
	"./customers/reports/balanceAdjustments/table.js": 459,
	"./customers/reports/balanceHistory": 1382,
	"./customers/reports/balanceHistory.js": 1382,
	"./customers/reports/balanceHistory/filter": 460,
	"./customers/reports/balanceHistory/filter.js": 460,
	"./customers/reports/balanceHistory/table": 461,
	"./customers/reports/balanceHistory/table.js": 461,
	"./customers/reports/betsReport": 1383,
	"./customers/reports/betsReport.js": 1383,
	"./customers/reports/betsReport/detailsReport": 1384,
	"./customers/reports/betsReport/detailsReport.js": 1384,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 446,
	"./customers/reports/bonusReport2/filterBonusReport.js": 446,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1385,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1385,
	"./customers/reports/bonusReport2/tableBonusReport": 447,
	"./customers/reports/bonusReport2/tableBonusReport.js": 447,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1386,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1386,
	"./customers/reports/casinoReport2/filterCasinoReport": 1387,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1387,
	"./customers/reports/casinoReport2/recordCasinoReport": 1388,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1388,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1389,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1389,
	"./customers/reports/casinoReport2/tableCasinoReport": 1390,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1390,
	"./customers/reports/deposit_report/detailsDepositReports": 169,
	"./customers/reports/deposit_report/detailsDepositReports.js": 169,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1391,
	"./customers/reports/historyMovement.js": 1391,
	"./customers/reports/historyMovement/filter": 462,
	"./customers/reports/historyMovement/filter.js": 462,
	"./customers/reports/historyMovement/table": 463,
	"./customers/reports/historyMovement/table.js": 463,
	"./customers/reports/historyPoints": 1392,
	"./customers/reports/historyPoints.js": 1392,
	"./customers/reports/historyPoints/filter": 464,
	"./customers/reports/historyPoints/filter.js": 464,
	"./customers/reports/historyPoints/table": 465,
	"./customers/reports/historyPoints/table.js": 465,
	"./customers/reports/logsUser": 1393,
	"./customers/reports/logsUser.js": 1393,
	"./customers/reports/logsUser/filter": 466,
	"./customers/reports/logsUser/filter.js": 466,
	"./customers/reports/logsUser/table": 467,
	"./customers/reports/logsUser/table.js": 467,
	"./customers/reports/notesUser": 1394,
	"./customers/reports/notesUser.js": 1394,
	"./customers/reports/notesUser/filter": 468,
	"./customers/reports/notesUser/filter.js": 468,
	"./customers/reports/notesUser/table": 469,
	"./customers/reports/notesUser/table.js": 469,
	"./customers/reports/playerPrizesLoyalty": 1395,
	"./customers/reports/playerPrizesLoyalty.js": 1395,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 470,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 470,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 471,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 471,
	"./customers/reports/playerRoulette": 1396,
	"./customers/reports/playerRoulette.js": 1396,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 472,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 472,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 473,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 473,
	"./customers/reports/referralsReport/filterReferralsReports": 456,
	"./customers/reports/referralsReport/filterReferralsReports.js": 456,
	"./customers/reports/referralsReport/recordReferralsReports": 1397,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1397,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1398,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1398,
	"./customers/reports/referralsReport/tableReferralsReports": 457,
	"./customers/reports/referralsReport/tableReferralsReports.js": 457,
	"./customers/reports/registeredDocument": 1399,
	"./customers/reports/registeredDocument.js": 1399,
	"./customers/reports/registeredDocuments/filter": 474,
	"./customers/reports/registeredDocuments/filter.js": 474,
	"./customers/reports/registeredDocuments/table": 475,
	"./customers/reports/registeredDocuments/table.js": 475,
	"./customers/reports/sessionsReport": 1400,
	"./customers/reports/sessionsReport.js": 1400,
	"./customers/reports/sessionsReport/detailsSessionsReport": 478,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 478,
	"./customers/reports/sessionsReport/filterSessionsReport": 476,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 476,
	"./customers/reports/sessionsReport/recordSessionsReport": 1004,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1004,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1005,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1005,
	"./customers/reports/sessionsReport/tableSessionsReport": 477,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 477,
	"./customers/reports/sessionsReport2": 1401,
	"./customers/reports/sessionsReport2.js": 1401,
	"./customers/reports/sessionsReport2/filter": 479,
	"./customers/reports/sessionsReport2/filter.js": 479,
	"./customers/reports/sessionsReport2/table": 480,
	"./customers/reports/sessionsReport2/table.js": 480,
	"./customers/reports/walletsReport": 1402,
	"./customers/reports/walletsReport.js": 1402,
	"./customers/reports/walletsReport/filter": 481,
	"./customers/reports/walletsReport/filter.js": 481,
	"./customers/reports/walletsReport/table": 482,
	"./customers/reports/walletsReport/table.js": 482,
	"./customers/reportscustomer": 1403,
	"./customers/reportscustomer.js": 1403,
	"./customers/statistics": 1404,
	"./customers/statistics.js": 1404,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1405,
	"./customersAggregator.js": 1405,
	"./customersAggregator/age": 1406,
	"./customersAggregator/age.js": 1406,
	"./customersAggregator/bonusReport": 1407,
	"./customersAggregator/bonusReport.js": 1407,
	"./customersAggregator/casinoGamesReport": 1408,
	"./customersAggregator/casinoGamesReport.js": 1408,
	"./customersAggregator/configuration": 1409,
	"./customersAggregator/configuration.js": 1409,
	"./customersAggregator/configuration/changePassword": 1410,
	"./customersAggregator/configuration/changePassword.js": 1410,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1411,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1411,
	"./customersAggregator/configuration/generateToken": 1412,
	"./customersAggregator/configuration/generateToken.js": 1412,
	"./customersAggregator/configuration/generateToken/filter": 1413,
	"./customersAggregator/configuration/generateToken/filter.js": 1413,
	"./customersAggregator/configuration/generateToken/table": 1414,
	"./customersAggregator/configuration/generateToken/table.js": 1414,
	"./customersAggregator/configuration/securityChanges": 1415,
	"./customersAggregator/configuration/securityChanges.js": 1415,
	"./customersAggregator/configuration/securityChanges/filter": 1416,
	"./customersAggregator/configuration/securityChanges/filter.js": 1416,
	"./customersAggregator/configuration/securityChanges/table": 1417,
	"./customersAggregator/configuration/securityChanges/table.js": 1417,
	"./customersAggregator/depositReport": 1418,
	"./customersAggregator/depositReport.js": 1418,
	"./customersAggregator/financescustomer": 1419,
	"./customersAggregator/financescustomer.js": 1419,
	"./customersAggregator/financial/bankAccounts": 1420,
	"./customersAggregator/financial/bankAccounts.js": 1420,
	"./customersAggregator/financial/bankAccounts/details": 1421,
	"./customersAggregator/financial/bankAccounts/details.js": 1421,
	"./customersAggregator/financial/bankAccounts/filter": 1422,
	"./customersAggregator/financial/bankAccounts/filter.js": 1422,
	"./customersAggregator/financial/bankAccounts/record": 1423,
	"./customersAggregator/financial/bankAccounts/record.js": 1423,
	"./customersAggregator/financial/bankAccounts/recordTable": 1424,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1424,
	"./customersAggregator/financial/bankAccounts/table": 1425,
	"./customersAggregator/financial/bankAccounts/table.js": 1425,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1426,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1426,
	"./customersAggregator/financial/informationFinancial": 1427,
	"./customersAggregator/financial/informationFinancial.js": 1427,
	"./customersAggregator/financial/withdrawalRequests": 1428,
	"./customersAggregator/financial/withdrawalRequests.js": 1428,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1429,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1429,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1430,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1430,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1431,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1431,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1432,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1432,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1433,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1433,
	"./customersAggregator/geo": 1434,
	"./customersAggregator/geo.js": 1434,
	"./customersAggregator/information": 1435,
	"./customersAggregator/information.js": 1435,
	"./customersAggregator/money": 1436,
	"./customersAggregator/money.js": 1436,
	"./customersAggregator/paymenthistory": 1437,
	"./customersAggregator/paymenthistory.js": 1437,
	"./customersAggregator/players/filter": 1438,
	"./customersAggregator/players/filter.js": 1438,
	"./customersAggregator/players/table": 1439,
	"./customersAggregator/players/table.js": 1439,
	"./customersAggregator/playersAggregator/filter": 1440,
	"./customersAggregator/playersAggregator/filter.js": 1440,
	"./customersAggregator/playersAggregator/table": 1441,
	"./customersAggregator/playersAggregator/table.js": 1441,
	"./customersAggregator/positions": 1442,
	"./customersAggregator/positions.js": 1442,
	"./customersAggregator/reports/autoexclusionUsers": 1443,
	"./customersAggregator/reports/autoexclusionUsers.js": 1443,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1444,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1444,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1445,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1445,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1446,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1446,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1447,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1447,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1448,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1448,
	"./customersAggregator/reports/betsReport": 1449,
	"./customersAggregator/reports/betsReport.js": 1449,
	"./customersAggregator/reports/betsReport/detailsReport": 1450,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1450,
	"./customersAggregator/reports/betsReport/filterReport": 1451,
	"./customersAggregator/reports/betsReport/filterReport.js": 1451,
	"./customersAggregator/reports/betsReport/recordReport": 1452,
	"./customersAggregator/reports/betsReport/recordReport.js": 1452,
	"./customersAggregator/reports/betsReport/recordTableReport": 1453,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1453,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1454,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1454,
	"./customersAggregator/reports/betsReport/recordTransReport": 1455,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1455,
	"./customersAggregator/reports/betsReport/tableReport": 1456,
	"./customersAggregator/reports/betsReport/tableReport.js": 1456,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1457,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1457,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1458,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1458,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1459,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1459,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1460,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1460,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1461,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1461,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1462,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1462,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1463,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1463,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1464,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1464,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1465,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1465,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1466,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1466,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1467,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1467,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1468,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1468,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1469,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1469,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1470,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1470,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1471,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1471,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1472,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1472,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1473,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1473,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1474,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1474,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1475,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1475,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1476,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1476,
	"./customersAggregator/reportscustomer": 1477,
	"./customersAggregator/reportscustomer.js": 1477,
	"./customersAggregator/statistics": 1478,
	"./customersAggregator/statistics.js": 1478,
	"./customersAggregator/tags": 1479,
	"./customersAggregator/tags.js": 1479,
	"./dashboard": 1480,
	"./dashboard.js": 1480,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 483,
	"./dates.js": 483,
	"./demos": 1481,
	"./demos.js": 1481,
	"./depositReport": 1482,
	"./depositReport.js": 1482,
	"./depositReport2": 1483,
	"./depositReport2.js": 1483,
	"./depositReport3": 1484,
	"./depositReport3.js": 1484,
	"./depositReportBetShop": 1485,
	"./depositReportBetShop.js": 1485,
	"./depositRequests": 1486,
	"./depositRequests.js": 1486,
	"./eliminateNoteWithdraw": 1487,
	"./eliminateNoteWithdraw.js": 1487,
	"./emailsReport": 1488,
	"./emailsReport.js": 1488,
	"./financial/depositRequests/filter": 492,
	"./financial/depositRequests/filter.js": 492,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 494,
	"./financial/depositRequests/recordTable.js": 494,
	"./financial/depositRequests/table": 493,
	"./financial/depositRequests/table.js": 493,
	"./financial/withdrawalRequests": 1489,
	"./financial/withdrawalRequests.js": 1489,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 501,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 501,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1490,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1490,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 502,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 502,
	"./flujoCaja": 1491,
	"./flujoCaja.js": 1491,
	"./franchisee": 1492,
	"./franchisee.js": 1492,
	"./franchises": 1493,
	"./franchises.js": 1493,
	"./futureEvents": 1494,
	"./futureEvents.js": 1494,
	"./gamePerformanceReport": 1495,
	"./gamePerformanceReport.js": 1495,
	"./getReportStructureGames": 1496,
	"./getReportStructureGames.js": 1496,
	"./goldenRace": 1497,
	"./goldenRace.js": 1497,
	"./historicalCashFlow": 1498,
	"./historicalCashFlow.js": 1498,
	"./historyMovement": 1499,
	"./historyMovement.js": 1499,
	"./historyMovement/filter": 1500,
	"./historyMovement/filter.js": 1500,
	"./historyMovement/table": 1501,
	"./historyMovement/table.js": 1501,
	"./historyMovementBetShop": 1502,
	"./historyMovementBetShop.js": 1502,
	"./historyPoints": 1503,
	"./historyPoints.js": 1503,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1504,
	"./information/recordTable.js": 1504,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1505,
	"./informationCasino.js": 1505,
	"./informationHipica": 1506,
	"./informationHipica.js": 1506,
	"./informationLiveCasino": 1507,
	"./informationLiveCasino.js": 1507,
	"./informationVirtual": 1508,
	"./informationVirtual.js": 1508,
	"./informeCasino": 1509,
	"./informeCasino.js": 1509,
	"./informeGerencial": 1510,
	"./informeGerencial.js": 1510,
	"./informeGerencial2": 1511,
	"./informeGerencial2.js": 1511,
	"./informeGerencialAgentes2": 1512,
	"./informeGerencialAgentes2.js": 1512,
	"./informeGerencialUsuarios2": 1513,
	"./informeGerencialUsuarios2.js": 1513,
	"./jackpotPaymentReports": 1514,
	"./jackpotPaymentReports.js": 1514,
	"./jackpotPaymentReports2": 1515,
	"./jackpotPaymentReports2.js": 1515,
	"./jackpotPrizeReport": 1516,
	"./jackpotPrizeReport.js": 1516,
	"./jackpotPrizeReportSportBet": 1517,
	"./jackpotPrizeReportSportBet.js": 1517,
	"./jackpotWinnersReport": 1518,
	"./jackpotWinnersReport.js": 1518,
	"./landingReport": 1519,
	"./landingReport.js": 1519,
	"./landingReport2": 1520,
	"./landingReport2.js": 1520,
	"./leagues/AddLeague": 1521,
	"./leagues/AddLeague.js": 1521,
	"./leagues/addLeagueManagement": 1522,
	"./leagues/addLeagueManagement.js": 1522,
	"./leagues/configuration": 1523,
	"./leagues/configuration.js": 1523,
	"./leagues/configuration/changePassword": 1524,
	"./leagues/configuration/changePassword.js": 1524,
	"./leagues/configuration/changePassword/changePasswordView": 1525,
	"./leagues/configuration/changePassword/changePasswordView.js": 1525,
	"./leagues/configuration/generateToken": 1526,
	"./leagues/configuration/generateToken.js": 1526,
	"./leagues/configuration/generateToken/filter": 1527,
	"./leagues/configuration/generateToken/filter.js": 1527,
	"./leagues/configuration/generateToken/table": 1528,
	"./leagues/configuration/generateToken/table.js": 1528,
	"./leagues/configuration/qrgoogle": 1529,
	"./leagues/configuration/qrgoogle.js": 1529,
	"./leagues/configuration/securityChanges": 1530,
	"./leagues/configuration/securityChanges.js": 1530,
	"./leagues/configuration/securityChanges/filter": 1531,
	"./leagues/configuration/securityChanges/filter.js": 1531,
	"./leagues/configuration/securityChanges/table": 1532,
	"./leagues/configuration/securityChanges/table.js": 1532,
	"./leagues/information": 1533,
	"./leagues/information.js": 1533,
	"./leagues/leagues-list/filter": 552,
	"./leagues/leagues-list/filter.js": 552,
	"./leagues/leagues-list/table": 553,
	"./leagues/leagues-list/table.js": 553,
	"./leagues/leaguesList": 1534,
	"./leagues/leaguesList.js": 1534,
	"./leagues/leaguesManagement": 1535,
	"./leagues/leaguesManagement.js": 1535,
	"./leagues/reports": 1536,
	"./leagues/reports.js": 1536,
	"./leagues/reports/betsReport": 1537,
	"./leagues/reports/betsReport.js": 1537,
	"./leagues/reports/betsReport/detailsReport": 1538,
	"./leagues/reports/betsReport/detailsReport.js": 1538,
	"./leagues/reports/betsReport/filterReport": 555,
	"./leagues/reports/betsReport/filterReport.js": 555,
	"./leagues/reports/betsReport/recordReport": 1539,
	"./leagues/reports/betsReport/recordReport.js": 1539,
	"./leagues/reports/betsReport/recordTableReport": 1540,
	"./leagues/reports/betsReport/recordTableReport.js": 1540,
	"./leagues/reports/betsReport/recordTableTransReport": 1541,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1541,
	"./leagues/reports/betsReport/recordTransReport": 557,
	"./leagues/reports/betsReport/recordTransReport.js": 557,
	"./leagues/reports/betsReport/tableReport": 556,
	"./leagues/reports/betsReport/tableReport.js": 556,
	"./leagues/reports/casinoGamesReport": 1542,
	"./leagues/reports/casinoGamesReport.js": 1542,
	"./leagues/reports/casinoReport/detailsCasinoReport": 560,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 560,
	"./leagues/reports/casinoReport/filterCasinoReport": 558,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 558,
	"./leagues/reports/casinoReport/recordCasinoReport": 561,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 561,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1543,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1543,
	"./leagues/reports/casinoReport/tableCasinoReport": 559,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 559,
	"./leagues/reports/userAfilliatesReport": 1544,
	"./leagues/reports/userAfilliatesReport.js": 1544,
	"./leagues/reports/user_affiliates/detailsReports": 1545,
	"./leagues/reports/user_affiliates/detailsReports.js": 1545,
	"./leagues/reports/user_affiliates/filterReports": 562,
	"./leagues/reports/user_affiliates/filterReports.js": 562,
	"./leagues/reports/user_affiliates/recordReports": 1546,
	"./leagues/reports/user_affiliates/recordReports.js": 1546,
	"./leagues/reports/user_affiliates/recordTableReports": 1547,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1547,
	"./leagues/reports/user_affiliates/tableReports": 563,
	"./leagues/reports/user_affiliates/tableReports.js": 563,
	"./leagues/results/recordTableResponts": 554,
	"./leagues/results/recordTableResponts.js": 554,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1548,
	"./leagues/statistics.js": 1548,
	"./leagues/statistics/age": 567,
	"./leagues/statistics/age.js": 567,
	"./leagues/statistics/marketing": 565,
	"./leagues/statistics/marketing.js": 565,
	"./leagues/statistics/marketingvsregistros": 566,
	"./leagues/statistics/marketingvsregistros.js": 566,
	"./leagues/statistics/money": 564,
	"./leagues/statistics/money.js": 564,
	"./limitationsReport": 1549,
	"./limitationsReport.js": 1549,
	"./loading": 1550,
	"./loading.js": 1550,
	"./login": 1551,
	"./login.js": 1551,
	"./logsUserGeneral": 1552,
	"./logsUserGeneral.js": 1552,
	"./loteryReport": 1553,
	"./loteryReport.js": 1553,
	"./machine/AddMachineRegister": 1554,
	"./machine/AddMachineRegister.js": 1554,
	"./machine/addMachineManagement": 1555,
	"./machine/addMachineManagement.js": 1555,
	"./machine/cashier/advertising": 575,
	"./machine/cashier/advertising.js": 575,
	"./machine/cashier/cashier": 1556,
	"./machine/cashier/cashier.js": 1556,
	"./machine/cashier/tableAdvertising": 576,
	"./machine/cashier/tableAdvertising.js": 576,
	"./machine/configuration": 1557,
	"./machine/configuration.js": 1557,
	"./machine/configuration/changePassword": 1558,
	"./machine/configuration/changePassword.js": 1558,
	"./machine/configuration/changePassword/changePasswordView": 1559,
	"./machine/configuration/changePassword/changePasswordView.js": 1559,
	"./machine/configuration/generateToken": 1560,
	"./machine/configuration/generateToken.js": 1560,
	"./machine/configuration/generateToken/filter": 1561,
	"./machine/configuration/generateToken/filter.js": 1561,
	"./machine/configuration/generateToken/table": 1562,
	"./machine/configuration/generateToken/table.js": 1562,
	"./machine/configuration/qrgoogle": 1563,
	"./machine/configuration/qrgoogle.js": 1563,
	"./machine/configuration/securityChanges": 1564,
	"./machine/configuration/securityChanges.js": 1564,
	"./machine/configuration/securityChanges/filter": 1009,
	"./machine/configuration/securityChanges/filter.js": 1009,
	"./machine/configuration/securityChanges/table": 577,
	"./machine/configuration/securityChanges/table.js": 577,
	"./machine/filter": 578,
	"./machine/filter.js": 578,
	"./machine/information": 1565,
	"./machine/information.js": 1565,
	"./machine/machineManagement": 1566,
	"./machine/machineManagement.js": 1566,
	"./machine/machineRegister": 1567,
	"./machine/machineRegister.js": 1567,
	"./machine/managePointsGraphics": 1568,
	"./machine/managePointsGraphics.js": 1568,
	"./machine/pagoNotaCobro": 1569,
	"./machine/pagoNotaCobro.js": 1569,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1010,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1010,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 582,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 582,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 583,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 583,
	"./machine/pagoPremioMaquina": 1570,
	"./machine/pagoPremioMaquina.js": 1570,
	"./machine/pagopremio/PagoPremio": 585,
	"./machine/pagopremio/PagoPremio.js": 585,
	"./machine/pagopremio/detailsPagoPremio": 587,
	"./machine/pagopremio/detailsPagoPremio.js": 587,
	"./machine/pagopremio/filterPagoPremio": 584,
	"./machine/pagopremio/filterPagoPremio.js": 584,
	"./machine/pagopremio/recordPagoPremio": 588,
	"./machine/pagopremio/recordPagoPremio.js": 588,
	"./machine/pagopremio/recordTablePagoPremio": 1571,
	"./machine/pagopremio/recordTablePagoPremio.js": 1571,
	"./machine/pagopremio/tablePagoPremio": 586,
	"./machine/pagopremio/tablePagoPremio.js": 586,
	"./machine/pointsGraphics/filter": 580,
	"./machine/pointsGraphics/filter.js": 580,
	"./machine/pointsGraphics/pointsList": 581,
	"./machine/pointsGraphics/pointsList.js": 581,
	"./machine/products2": 1572,
	"./machine/products2.js": 1572,
	"./machine/products2/categories-products/filter": 589,
	"./machine/products2/categories-products/filter.js": 589,
	"./machine/products2/categories-products/table": 590,
	"./machine/products2/categories-products/table.js": 590,
	"./machine/products2/categoriesProducts": 1573,
	"./machine/products2/categoriesProducts.js": 1573,
	"./machine/products2/partners-games/filter": 591,
	"./machine/products2/partners-games/filter.js": 591,
	"./machine/products2/partners-games/table": 592,
	"./machine/products2/partners-games/table.js": 592,
	"./machine/products2/partners-products/filter": 593,
	"./machine/products2/partners-products/filter.js": 593,
	"./machine/products2/partners-products/table": 594,
	"./machine/products2/partners-products/table.js": 594,
	"./machine/products2/partners-providers/filter": 595,
	"./machine/products2/partners-providers/filter.js": 595,
	"./machine/products2/partners-providers/table": 596,
	"./machine/products2/partners-providers/table.js": 596,
	"./machine/products2/partners-subProviders/filter": 597,
	"./machine/products2/partners-subProviders/filter.js": 597,
	"./machine/products2/partners-subProviders/table": 598,
	"./machine/products2/partners-subProviders/table.js": 598,
	"./machine/products2/partners-tipoproducto/filter": 599,
	"./machine/products2/partners-tipoproducto/filter.js": 599,
	"./machine/products2/partners-tipoproducto/table": 600,
	"./machine/products2/partners-tipoproducto/table.js": 600,
	"./machine/products2/partnersGames": 1574,
	"./machine/products2/partnersGames.js": 1574,
	"./machine/products2/partnersProducts": 1575,
	"./machine/products2/partnersProducts.js": 1575,
	"./machine/products2/partnersProviders": 1576,
	"./machine/products2/partnersProviders.js": 1576,
	"./machine/products2/partnersSubProviders": 1577,
	"./machine/products2/partnersSubProviders.js": 1577,
	"./machine/products2/partnersTypeProduct": 1578,
	"./machine/products2/partnersTypeProduct.js": 1578,
	"./machine/reports": 1579,
	"./machine/reports.js": 1579,
	"./machine/reports/betsReport": 1580,
	"./machine/reports/betsReport.js": 1580,
	"./machine/reports/betsReport/detailsReport": 1581,
	"./machine/reports/betsReport/detailsReport.js": 1581,
	"./machine/reports/betsReport/filterReport": 601,
	"./machine/reports/betsReport/filterReport.js": 601,
	"./machine/reports/betsReport/recordReport": 1582,
	"./machine/reports/betsReport/recordReport.js": 1582,
	"./machine/reports/betsReport/recordTableReport": 1583,
	"./machine/reports/betsReport/recordTableReport.js": 1583,
	"./machine/reports/betsReport/recordTableTransReport": 1584,
	"./machine/reports/betsReport/recordTableTransReport.js": 1584,
	"./machine/reports/betsReport/recordTransReport": 603,
	"./machine/reports/betsReport/recordTransReport.js": 603,
	"./machine/reports/betsReport/tableReport": 602,
	"./machine/reports/betsReport/tableReport.js": 602,
	"./machine/reports/casinoGamesReport": 1585,
	"./machine/reports/casinoGamesReport.js": 1585,
	"./machine/reports/casinoReport/detailsCasinoReport": 606,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 606,
	"./machine/reports/casinoReport/filterCasinoReport": 604,
	"./machine/reports/casinoReport/filterCasinoReport.js": 604,
	"./machine/reports/casinoReport/recordCasinoReport": 607,
	"./machine/reports/casinoReport/recordCasinoReport.js": 607,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1586,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1586,
	"./machine/reports/casinoReport/tableCasinoReport": 605,
	"./machine/reports/casinoReport/tableCasinoReport.js": 605,
	"./machine/reports/depositReport": 1587,
	"./machine/reports/depositReport.js": 1587,
	"./machine/reports/deposit_report/detailsDepositReports": 1011,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1011,
	"./machine/reports/deposit_report/filterDepositReports": 608,
	"./machine/reports/deposit_report/filterDepositReports.js": 608,
	"./machine/reports/deposit_report/recordDepositReports": 610,
	"./machine/reports/deposit_report/recordDepositReports.js": 610,
	"./machine/reports/deposit_report/recordTableDepositReports": 1588,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1588,
	"./machine/reports/deposit_report/tableDepositReports": 609,
	"./machine/reports/deposit_report/tableDepositReports.js": 609,
	"./machine/reports/flujoCaja": 1589,
	"./machine/reports/flujoCaja.js": 1589,
	"./machine/reports/flujocaja/detailsFlujoCaja": 613,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 613,
	"./machine/reports/flujocaja/filterFlujoCaja": 611,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 611,
	"./machine/reports/flujocaja/recordFlujoCaja": 614,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 614,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1590,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1590,
	"./machine/reports/flujocaja/tableFlujoCaja": 612,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 612,
	"./machine/reports/log/log": 615,
	"./machine/reports/log/log.js": 615,
	"./machine/reports/logReport": 1591,
	"./machine/reports/logReport.js": 1591,
	"./machine/reports/updates/filter": 616,
	"./machine/reports/updates/filter.js": 616,
	"./machine/reports/updates/table": 617,
	"./machine/reports/updates/table.js": 617,
	"./machine/reports/updatesReport": 1592,
	"./machine/reports/updatesReport.js": 1592,
	"./machine/reports/userAfilliatesReport": 1593,
	"./machine/reports/userAfilliatesReport.js": 1593,
	"./machine/reports/user_affiliates/detailsReports": 1594,
	"./machine/reports/user_affiliates/detailsReports.js": 1594,
	"./machine/reports/user_affiliates/filterReports": 618,
	"./machine/reports/user_affiliates/filterReports.js": 618,
	"./machine/reports/user_affiliates/recordReports": 1595,
	"./machine/reports/user_affiliates/recordReports.js": 1595,
	"./machine/reports/user_affiliates/recordTableReports": 1596,
	"./machine/reports/user_affiliates/recordTableReports.js": 1596,
	"./machine/reports/user_affiliates/tableReports": 619,
	"./machine/reports/user_affiliates/tableReports.js": 619,
	"./machine/reports/withdrawalRequests": 1597,
	"./machine/reports/withdrawalRequests.js": 1597,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 622,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 622,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 620,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 620,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1598,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1598,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 623,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 623,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 621,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 621,
	"./machine/results/recordTableResponts": 1599,
	"./machine/results/recordTableResponts.js": 1599,
	"./machine/results/tableResults": 1600,
	"./machine/results/tableResults.js": 1600,
	"./machine/statistics": 1601,
	"./machine/statistics.js": 1601,
	"./machine/statistics/age": 627,
	"./machine/statistics/age.js": 627,
	"./machine/statistics/marketing": 625,
	"./machine/statistics/marketing.js": 625,
	"./machine/statistics/marketingvsregistros": 626,
	"./machine/statistics/marketingvsregistros.js": 626,
	"./machine/statistics/money": 624,
	"./machine/statistics/money.js": 624,
	"./machine/table": 579,
	"./machine/table.js": 579,
	"./management/activateRegistration/filter": 201,
	"./management/activateRegistration/filter.js": 201,
	"./management/activateRegistration/response": 202,
	"./management/activateRegistration/response.js": 202,
	"./management/coupons/coupons": 437,
	"./management/coupons/coupons.js": 437,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 496,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 496,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 495,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 495,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 498,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 498,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 497,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 497,
	"./management/faltan.txt": 1931,
	"./management/managementClaims/filter": 628,
	"./management/managementClaims/filter.js": 628,
	"./management/managementClaims/table": 629,
	"./management/managementClaims/table.js": 629,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 630,
	"./management/managementContact/detailsTable.js": 630,
	"./management/managementContact/filterManagementContact": 631,
	"./management/managementContact/filterManagementContact.js": 631,
	"./management/managementContact/tableManagementContact": 632,
	"./management/managementContact/tableManagementContact.js": 632,
	"./management/managementContactUser/filter": 633,
	"./management/managementContactUser/filter.js": 633,
	"./management/managementContactUser/table": 634,
	"./management/managementContactUser/table.js": 634,
	"./management/managementGenericForms/filter": 635,
	"./management/managementGenericForms/filter.js": 635,
	"./management/managementGenericForms/table": 636,
	"./management/managementGenericForms/table.js": 636,
	"./management/quotaRetraction/Retraction": 637,
	"./management/quotaRetraction/Retraction.js": 637,
	"./management/quotaRetraction/search": 1012,
	"./management/quotaRetraction/search.js": 1012,
	"./management/registerFast/filterRegisterFast": 638,
	"./management/registerFast/filterRegisterFast.js": 638,
	"./management/registerFast/tableRegisterFast": 639,
	"./management/registerFast/tableRegisterFast.js": 639,
	"./management/reprintCheck/filterReprintCheck": 640,
	"./management/reprintCheck/filterReprintCheck.js": 640,
	"./management/reprintCheck/tableReprintCheck": 641,
	"./management/reprintCheck/tableReprintCheck.js": 641,
	"./management/restrictUser/filter": 642,
	"./management/restrictUser/filter.js": 642,
	"./management/restrictUser/table": 643,
	"./management/restrictUser/table.js": 643,
	"./management/reversionReload/filterReversionReload": 644,
	"./management/reversionReload/filterReversionReload.js": 644,
	"./management/reversionReload/tableReversionReload": 645,
	"./management/reversionReload/tableReversionReload.js": 645,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 646,
	"./management/usersVerification/informationJumio.js": 646,
	"./managementClaims": 1602,
	"./managementClaims.js": 1602,
	"./managementContact": 1603,
	"./managementContact.js": 1603,
	"./managementContactUser": 1604,
	"./managementContactUser.js": 1604,
	"./managementGenericForms": 1605,
	"./managementGenericForms.js": 1605,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1606,
	"./menuBonus.js": 1606,
	"./menuBuilder": 1607,
	"./menuBuilder.js": 1607,
	"./menuMarketing": 1608,
	"./menuMarketing.js": 1608,
	"./menus": 1609,
	"./menus.js": 1609,
	"./messages/bannerInvasive": 1610,
	"./messages/bannerInvasive.js": 1610,
	"./messages/bannerInvasive/filter": 649,
	"./messages/bannerInvasive/filter.js": 649,
	"./messages/bannerInvasive/table": 650,
	"./messages/bannerInvasive/table.js": 650,
	"./messages/fringe": 1611,
	"./messages/fringe.js": 1611,
	"./messages/fringe/filter": 651,
	"./messages/fringe/filter.js": 651,
	"./messages/fringe/table": 652,
	"./messages/fringe/table.js": 652,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 653,
	"./messages/messageInternAgent/filter.js": 653,
	"./messages/messageInternAgent/table": 654,
	"./messages/messageInternAgent/table.js": 654,
	"./messages/messageInternal": 1612,
	"./messages/messageInternal.js": 1612,
	"./messages/messageInternalAgent": 1613,
	"./messages/messageInternalAgent.js": 1613,
	"./messages/messageList": 1614,
	"./messages/messageList.js": 1614,
	"./messages/popup": 1615,
	"./messages/popup.js": 1615,
	"./messages/popup/filter": 655,
	"./messages/popup/filter.js": 655,
	"./messages/popup/table": 656,
	"./messages/popup/table.js": 656,
	"./messagesOld/messageIntern/filter": 1616,
	"./messagesOld/messageIntern/filter.js": 1616,
	"./messagesOld/messageIntern/table": 1617,
	"./messagesOld/messageIntern/table.js": 1617,
	"./messagesOld/messageList": 1618,
	"./messagesOld/messageList.js": 1618,
	"./myComissionsReport": 1619,
	"./myComissionsReport.js": 1619,
	"./myConfiguration/changeMyPassword": 1620,
	"./myConfiguration/changeMyPassword.js": 1620,
	"./myConfiguration/myInfoBetShop": 1621,
	"./myConfiguration/myInfoBetShop.js": 1621,
	"./myConfiguration/myInfoCustomer": 1622,
	"./myConfiguration/myInfoCustomer.js": 1622,
	"./myConfiguration/myInformation": 1623,
	"./myConfiguration/myInformation.js": 1623,
	"./myConfiguration/qrgoogle": 1624,
	"./myConfiguration/qrgoogle.js": 1624,
	"./notesUser": 1625,
	"./notesUser.js": 1625,
	"./notifications": 984,
	"./notifications.js": 984,
	"./operatorResponsibility": 1626,
	"./operatorResponsibility.js": 1626,
	"./ownersIncome": 1627,
	"./ownersIncome.js": 1627,
	"./ownersIncomeSecondLevel": 1628,
	"./ownersIncomeSecondLevel.js": 1628,
	"./pagoNotaRetiro": 1629,
	"./pagoNotaRetiro.js": 1629,
	"./pagoPremio": 1630,
	"./pagoPremio.js": 1630,
	"./pagoPremioVirtuales": 1631,
	"./pagoPremioVirtuales.js": 1631,
	"./paidPendingAwards": 1632,
	"./paidPendingAwards.js": 1632,
	"./partner/PartnerSettings": 1633,
	"./partner/PartnerSettings.js": 1633,
	"./partner/PartnerSettingsOld": 1634,
	"./partner/PartnerSettingsOld.js": 1634,
	"./partner/TRM": 1635,
	"./partner/TRM.js": 1635,
	"./partner/TRM/filter": 671,
	"./partner/TRM/filter.js": 671,
	"./partner/TRM/table": 672,
	"./partner/TRM/table.js": 672,
	"./partner/configuration": 1636,
	"./partner/configuration.js": 1636,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1637,
	"./partner/configurationControl.js": 1637,
	"./partner/configurationControl/filter": 673,
	"./partner/configurationControl/filter.js": 673,
	"./partner/configurationControl/table": 674,
	"./partner/configurationControl/table.js": 674,
	"./partner/configurationControl2": 1638,
	"./partner/configurationControl2.js": 1638,
	"./partner/configurationControl2/filter": 675,
	"./partner/configurationControl2/filter.js": 675,
	"./partner/configurationControl2/table": 676,
	"./partner/configurationControl2/table.js": 676,
	"./partner/configurationOld/filter": 1639,
	"./partner/configurationOld/filter.js": 1639,
	"./partner/configurationOld/settings": 1640,
	"./partner/configurationOld/settings.js": 1640,
	"./partner/configurationSEO": 1641,
	"./partner/configurationSEO.js": 1641,
	"./partner/configurationSEO/filter": 677,
	"./partner/configurationSEO/filter.js": 677,
	"./partner/configurationSEO/settings": 678,
	"./partner/configurationSEO/settings.js": 678,
	"./partner/countries": 1642,
	"./partner/countries.js": 1642,
	"./partner/countries/countries": 679,
	"./partner/countries/countries.js": 679,
	"./partner/menusUser": 1643,
	"./partner/menusUser.js": 1643,
	"./partner/menusUser/filter": 680,
	"./partner/menusUser/filter.js": 680,
	"./partner/menusUser/table": 681,
	"./partner/menusUser/table.js": 681,
	"./partner/partner-list/filter": 669,
	"./partner/partner-list/filter.js": 669,
	"./partner/partner-list/table": 670,
	"./partner/partner-list/table.js": 670,
	"./partner/partnertManagement": 1644,
	"./partner/partnertManagement.js": 1644,
	"./partner/products": 1645,
	"./partner/products.js": 1645,
	"./partner/products/categories-products/filter": 682,
	"./partner/products/categories-products/filter.js": 682,
	"./partner/products/categories-products/table": 683,
	"./partner/products/categories-products/table.js": 683,
	"./partner/products/categoriesProducts": 1646,
	"./partner/products/categoriesProducts.js": 1646,
	"./partner/products/partners-products/filter": 684,
	"./partner/products/partners-products/filter.js": 684,
	"./partner/products/partners-products/table": 685,
	"./partner/products/partners-products/table.js": 685,
	"./partner/products/partners-providers/filter": 686,
	"./partner/products/partners-providers/filter.js": 686,
	"./partner/products/partners-providers/table": 687,
	"./partner/products/partners-providers/table.js": 687,
	"./partner/products/partners-subProviders/filter": 688,
	"./partner/products/partners-subProviders/filter.js": 688,
	"./partner/products/partners-subProviders/table": 689,
	"./partner/products/partners-subProviders/table.js": 689,
	"./partner/products/partners-tipoproducto/filter": 690,
	"./partner/products/partners-tipoproducto/filter.js": 690,
	"./partner/products/partners-tipoproducto/table": 691,
	"./partner/products/partners-tipoproducto/table.js": 691,
	"./partner/products/partnersProducts": 1647,
	"./partner/products/partnersProducts.js": 1647,
	"./partner/products/partnersProviders": 1648,
	"./partner/products/partnersProviders.js": 1648,
	"./partner/products/partnersSubProviders": 1649,
	"./partner/products/partnersSubProviders.js": 1649,
	"./partner/products/partnersTypeProduct": 1650,
	"./partner/products/partnersTypeProduct.js": 1650,
	"./partner/products/products-banks/filter": 692,
	"./partner/products/products-banks/filter.js": 692,
	"./partner/products/products-banks/table": 693,
	"./partner/products/products-banks/table.js": 693,
	"./partner/products/products-cryptoNetwork/filter": 694,
	"./partner/products/products-cryptoNetwork/filter.js": 694,
	"./partner/products/products-cryptoNetwork/table": 695,
	"./partner/products/products-cryptoNetwork/table.js": 695,
	"./partner/products/products-franchises/filter": 696,
	"./partner/products/products-franchises/filter.js": 696,
	"./partner/products/products-franchises/table": 697,
	"./partner/products/products-franchises/table.js": 697,
	"./partner/products/productsBanks": 1651,
	"./partner/products/productsBanks.js": 1651,
	"./partner/products/productsCryptoNetwork": 1652,
	"./partner/products/productsCryptoNetwork.js": 1652,
	"./partner/products/productsFranchises": 1653,
	"./partner/products/productsFranchises.js": 1653,
	"./partner/products2": 1654,
	"./partner/products2.js": 1654,
	"./partner/products2/banks-partners/filter": 698,
	"./partner/products2/banks-partners/filter.js": 698,
	"./partner/products2/banks-partners/table": 699,
	"./partner/products2/banks-partners/table.js": 699,
	"./partner/products2/categories-products/filter": 700,
	"./partner/products2/categories-products/filter.js": 700,
	"./partner/products2/categories-products/table": 701,
	"./partner/products2/categories-products/table.js": 701,
	"./partner/products2/categoriesProducts": 1655,
	"./partner/products2/categoriesProducts.js": 1655,
	"./partner/products2/enablement-products/filter": 702,
	"./partner/products2/enablement-products/filter.js": 702,
	"./partner/products2/enablement-products/table": 703,
	"./partner/products2/enablement-products/table.js": 703,
	"./partner/products2/enablementProducts": 1656,
	"./partner/products2/enablementProducts.js": 1656,
	"./partner/products2/franchises-partner/filter": 704,
	"./partner/products2/franchises-partner/filter.js": 704,
	"./partner/products2/franchises-partner/table": 705,
	"./partner/products2/franchises-partner/table.js": 705,
	"./partner/products2/partners-categories/filter": 706,
	"./partner/products2/partners-categories/filter.js": 706,
	"./partner/products2/partners-categories/table": 707,
	"./partner/products2/partners-categories/table.js": 707,
	"./partner/products2/partners-credentialsSubProviders/filter": 708,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 708,
	"./partner/products2/partners-credentialsSubProviders/table": 709,
	"./partner/products2/partners-credentialsSubProviders/table.js": 709,
	"./partner/products2/partners-games/filter": 710,
	"./partner/products2/partners-games/filter.js": 710,
	"./partner/products2/partners-games/table": 711,
	"./partner/products2/partners-games/table.js": 711,
	"./partner/products2/partners-products/filter": 712,
	"./partner/products2/partners-products/filter.js": 712,
	"./partner/products2/partners-products/table": 713,
	"./partner/products2/partners-products/table.js": 713,
	"./partner/products2/partners-providers-order/filter": 1657,
	"./partner/products2/partners-providers-order/filter.js": 1657,
	"./partner/products2/partners-providers-order/table": 1658,
	"./partner/products2/partners-providers-order/table.js": 1658,
	"./partner/products2/partners-providers/filter": 714,
	"./partner/products2/partners-providers/filter.js": 714,
	"./partner/products2/partners-providers/table": 715,
	"./partner/products2/partners-providers/table.js": 715,
	"./partner/products2/partners-subProviders-order/filter": 716,
	"./partner/products2/partners-subProviders-order/filter.js": 716,
	"./partner/products2/partners-subProviders-order/table": 717,
	"./partner/products2/partners-subProviders-order/table.js": 717,
	"./partner/products2/partners-subProviders/filter": 718,
	"./partner/products2/partners-subProviders/filter.js": 718,
	"./partner/products2/partners-subProviders/table": 719,
	"./partner/products2/partners-subProviders/table.js": 719,
	"./partner/products2/partners-tipoproducto/filter": 720,
	"./partner/products2/partners-tipoproducto/filter.js": 720,
	"./partner/products2/partners-tipoproducto/table": 721,
	"./partner/products2/partners-tipoproducto/table.js": 721,
	"./partner/products2/partnersBanks": 1659,
	"./partner/products2/partnersBanks.js": 1659,
	"./partner/products2/partnersCategories": 1660,
	"./partner/products2/partnersCategories.js": 1660,
	"./partner/products2/partnersCredentialsSubProviders": 1661,
	"./partner/products2/partnersCredentialsSubProviders.js": 1661,
	"./partner/products2/partnersFranchises": 1662,
	"./partner/products2/partnersFranchises.js": 1662,
	"./partner/products2/partnersGames": 1663,
	"./partner/products2/partnersGames.js": 1663,
	"./partner/products2/partnersProducts": 1664,
	"./partner/products2/partnersProducts.js": 1664,
	"./partner/products2/partnersProviders": 1665,
	"./partner/products2/partnersProviders.js": 1665,
	"./partner/products2/partnersSubProviders": 1666,
	"./partner/products2/partnersSubProviders.js": 1666,
	"./partner/products2/partnersSubProvidersOrder": 1667,
	"./partner/products2/partnersSubProvidersOrder.js": 1667,
	"./partner/products2/partnersTypeProduct": 1668,
	"./partner/products2/partnersTypeProduct.js": 1668,
	"./partner/reports": 1669,
	"./partner/reports.js": 1669,
	"./partner/reports/autoexclusionUsers": 1670,
	"./partner/reports/autoexclusionUsers.js": 1670,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 724,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 724,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 722,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 722,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1013,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1013,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 725,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 725,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 723,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 723,
	"./partner/reports/balanceAdjustments": 1671,
	"./partner/reports/balanceAdjustments.js": 1671,
	"./partner/reports/balanceAdjustments/filter": 726,
	"./partner/reports/balanceAdjustments/filter.js": 726,
	"./partner/reports/balanceAdjustments/table": 727,
	"./partner/reports/balanceAdjustments/table.js": 727,
	"./partner/reports/balanceHistory": 1672,
	"./partner/reports/balanceHistory.js": 1672,
	"./partner/reports/balanceHistory/filter": 728,
	"./partner/reports/balanceHistory/filter.js": 728,
	"./partner/reports/balanceHistory/table": 729,
	"./partner/reports/balanceHistory/table.js": 729,
	"./partner/reports/balanceHistoryBetShop": 1673,
	"./partner/reports/balanceHistoryBetShop.js": 1673,
	"./partner/reports/balanceHistoryBetShop/filter": 730,
	"./partner/reports/balanceHistoryBetShop/filter.js": 730,
	"./partner/reports/balanceHistoryBetShop/table": 731,
	"./partner/reports/balanceHistoryBetShop/table.js": 731,
	"./partner/reports/balanceUsers": 1674,
	"./partner/reports/balanceUsers.js": 1674,
	"./partner/reports/balanceUsers/filter": 732,
	"./partner/reports/balanceUsers/filter.js": 732,
	"./partner/reports/balanceUsers/record": 734,
	"./partner/reports/balanceUsers/record.js": 734,
	"./partner/reports/balanceUsers/resume": 735,
	"./partner/reports/balanceUsers/resume.js": 735,
	"./partner/reports/balanceUsers/table": 733,
	"./partner/reports/balanceUsers/table.js": 733,
	"./partner/reports/betsReport": 1675,
	"./partner/reports/betsReport.js": 1675,
	"./partner/reports/betsReport/detailsReport": 1676,
	"./partner/reports/betsReport/detailsReport.js": 1676,
	"./partner/reports/betsReport/filterReport": 736,
	"./partner/reports/betsReport/filterReport.js": 736,
	"./partner/reports/betsReport/recordReport": 740,
	"./partner/reports/betsReport/recordReport.js": 740,
	"./partner/reports/betsReport/recordTableReport": 741,
	"./partner/reports/betsReport/recordTableReport.js": 741,
	"./partner/reports/betsReport/recordTableTransReport": 739,
	"./partner/reports/betsReport/recordTableTransReport.js": 739,
	"./partner/reports/betsReport/recordTransReport": 738,
	"./partner/reports/betsReport/recordTransReport.js": 738,
	"./partner/reports/betsReport/tableReport": 737,
	"./partner/reports/betsReport/tableReport.js": 737,
	"./partner/reports/bonusReport": 1677,
	"./partner/reports/bonusReport.js": 1677,
	"./partner/reports/bonusReport/detailsBonusReport": 744,
	"./partner/reports/bonusReport/detailsBonusReport.js": 744,
	"./partner/reports/bonusReport/filterBonusReport": 742,
	"./partner/reports/bonusReport/filterBonusReport.js": 742,
	"./partner/reports/bonusReport/recordBonusReport": 745,
	"./partner/reports/bonusReport/recordBonusReport.js": 745,
	"./partner/reports/bonusReport/recordTableBonusReport": 746,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 746,
	"./partner/reports/bonusReport/tableBonusReport": 743,
	"./partner/reports/bonusReport/tableBonusReport.js": 743,
	"./partner/reports/casinoGamesReport": 1678,
	"./partner/reports/casinoGamesReport.js": 1678,
	"./partner/reports/casinoReport/detailsCasinoReport": 749,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 749,
	"./partner/reports/casinoReport/filterCasinoReport": 747,
	"./partner/reports/casinoReport/filterCasinoReport.js": 747,
	"./partner/reports/casinoReport/recordCasinoReport": 750,
	"./partner/reports/casinoReport/recordCasinoReport.js": 750,
	"./partner/reports/casinoReport/recordTableCasinoReport": 751,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 751,
	"./partner/reports/casinoReport/tableCasinoReport": 748,
	"./partner/reports/casinoReport/tableCasinoReport.js": 748,
	"./partner/reports/comissionsReport": 1679,
	"./partner/reports/comissionsReport.js": 1679,
	"./partner/reports/comissions_report/filter": 752,
	"./partner/reports/comissions_report/filter.js": 752,
	"./partner/reports/comissions_report/table": 753,
	"./partner/reports/comissions_report/table.js": 753,
	"./partner/reports/depositReport": 1680,
	"./partner/reports/depositReport.js": 1680,
	"./partner/reports/deposit_report/detailsDepositReports": 1014,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1014,
	"./partner/reports/deposit_report/filterDepositReports": 754,
	"./partner/reports/deposit_report/filterDepositReports.js": 754,
	"./partner/reports/deposit_report/recordDepositReports": 756,
	"./partner/reports/deposit_report/recordDepositReports.js": 756,
	"./partner/reports/deposit_report/recordTableDepositReports": 757,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 757,
	"./partner/reports/deposit_report/tableDepositReports": 755,
	"./partner/reports/deposit_report/tableDepositReports.js": 755,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 758,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 758,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 759,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 759,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 760,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 760,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 761,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 761,
	"./partner/reports/historicalCashFlow": 1681,
	"./partner/reports/historicalCashFlow.js": 1681,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 764,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 764,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 762,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 762,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 765,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 765,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 766,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 766,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 763,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 763,
	"./partner/reports/historyMovement": 1682,
	"./partner/reports/historyMovement.js": 1682,
	"./partner/reports/historyMovement/filter": 767,
	"./partner/reports/historyMovement/filter.js": 767,
	"./partner/reports/historyMovement/table": 768,
	"./partner/reports/historyMovement/table.js": 768,
	"./partner/reports/informeCasino/detailsInformeCasino": 1683,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1683,
	"./partner/reports/informeCasino/filterInformeCasino": 1684,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1684,
	"./partner/reports/informeCasino/recordInformeCasino": 1685,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1685,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1686,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1686,
	"./partner/reports/informeCasino/tableInformeCasino": 1687,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1687,
	"./partner/reports/informeGerencial": 1688,
	"./partner/reports/informeGerencial.js": 1688,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 771,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 771,
	"./partner/reports/informeGerencial/filterInformeGerencial": 769,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 769,
	"./partner/reports/informeGerencial/recordInformeGerencial": 772,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 772,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 773,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 773,
	"./partner/reports/informeGerencial/tableInformeGerencial": 770,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 770,
	"./partner/reports/landingReport/detailsLandingReport": 1689,
	"./partner/reports/landingReport/detailsLandingReport.js": 1689,
	"./partner/reports/landingReport/filterLandingReport": 1690,
	"./partner/reports/landingReport/filterLandingReport.js": 1690,
	"./partner/reports/landingReport/recordLandingReport": 1691,
	"./partner/reports/landingReport/recordLandingReport.js": 1691,
	"./partner/reports/landingReport/recordTableLandingReport": 1692,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1692,
	"./partner/reports/landingReport/tableLandingReport": 1693,
	"./partner/reports/landingReport/tableLandingReport.js": 1693,
	"./partner/reports/logsUser/filter": 1694,
	"./partner/reports/logsUser/filter.js": 1694,
	"./partner/reports/logsUser/table": 1695,
	"./partner/reports/logsUser/table.js": 1695,
	"./partner/reports/operatorResponsibility/filter": 1696,
	"./partner/reports/operatorResponsibility/filter.js": 1696,
	"./partner/reports/operatorResponsibility/table": 1697,
	"./partner/reports/operatorResponsibility/table.js": 1697,
	"./partner/reports/paidPendingAwards": 1698,
	"./partner/reports/paidPendingAwards.js": 1698,
	"./partner/reports/playersReport/detailsPlayersReport": 1699,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1699,
	"./partner/reports/playersReport/filterPlayersReport": 1700,
	"./partner/reports/playersReport/filterPlayersReport.js": 1700,
	"./partner/reports/playersReport/recordPlayersReport": 1701,
	"./partner/reports/playersReport/recordPlayersReport.js": 1701,
	"./partner/reports/playersReport/recordTablePlayersReport": 777,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 777,
	"./partner/reports/playersReport/tablePlayersReport": 1702,
	"./partner/reports/playersReport/tablePlayersReport.js": 1702,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1015,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1015,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 774,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 774,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1016,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1016,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 776,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 776,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 775,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 775,
	"./partner/reports/promotionalCodes/filter": 1703,
	"./partner/reports/promotionalCodes/filter.js": 1703,
	"./partner/reports/promotionalCodes/table": 1704,
	"./partner/reports/promotionalCodes/table.js": 1704,
	"./partner/reports/quotaRetraction/filter": 1705,
	"./partner/reports/quotaRetraction/filter.js": 1705,
	"./partner/reports/quotaRetraction/table": 1706,
	"./partner/reports/quotaRetraction/table.js": 1706,
	"./partner/reports/registeredDocument": 1707,
	"./partner/reports/registeredDocument.js": 1707,
	"./partner/reports/registeredDocuments/filter": 778,
	"./partner/reports/registeredDocuments/filter.js": 778,
	"./partner/reports/registeredDocuments/table": 779,
	"./partner/reports/registeredDocuments/table.js": 779,
	"./partner/reports/relationUserAggregator": 1708,
	"./partner/reports/relationUserAggregator.js": 1708,
	"./partner/reports/relationUserAggregator/filter": 780,
	"./partner/reports/relationUserAggregator/filter.js": 780,
	"./partner/reports/relationUserAggregator/table": 781,
	"./partner/reports/relationUserAggregator/table.js": 781,
	"./partner/reports/reportHash/filter": 1709,
	"./partner/reports/reportHash/filter.js": 1709,
	"./partner/reports/reportHash/table": 1710,
	"./partner/reports/reportHash/table.js": 1710,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1711,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1711,
	"./partner/reports/sessionsReport/filterSessionsReport": 1712,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1712,
	"./partner/reports/sessionsReport/recordSessionsReport": 1713,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1713,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1017,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1017,
	"./partner/reports/sessionsReport/tableSessionsReport": 1714,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1714,
	"./partner/reports/sportsTransactions": 1715,
	"./partner/reports/sportsTransactions.js": 1715,
	"./partner/reports/sportsTransactions/filter": 782,
	"./partner/reports/sportsTransactions/filter.js": 782,
	"./partner/reports/sportsTransactions/table": 783,
	"./partner/reports/sportsTransactions/table.js": 783,
	"./partner/reports/summaryCashFlow": 1716,
	"./partner/reports/summaryCashFlow.js": 1716,
	"./partner/reports/taxableEarnings/filter": 1717,
	"./partner/reports/taxableEarnings/filter.js": 1717,
	"./partner/reports/taxableEarnings/table": 1718,
	"./partner/reports/taxableEarnings/table.js": 1718,
	"./partner/reports/transfersReport/filter": 1719,
	"./partner/reports/transfersReport/filter.js": 1719,
	"./partner/reports/transfersReport/table": 1720,
	"./partner/reports/transfersReport/table.js": 1720,
	"./partner/reports/usuarioOnlineResumido": 1721,
	"./partner/reports/usuarioOnlineResumido.js": 1721,
	"./partner/reports/usuarioOnlineResumido/filter": 784,
	"./partner/reports/usuarioOnlineResumido/filter.js": 784,
	"./partner/reports/usuarioOnlineResumido/table": 785,
	"./partner/reports/usuarioOnlineResumido/table.js": 785,
	"./partner/reports/wallets": 1722,
	"./partner/reports/wallets.js": 1722,
	"./partner/reports/wallets/filter": 786,
	"./partner/reports/wallets/filter.js": 786,
	"./partner/reports/wallets/table": 787,
	"./partner/reports/wallets/table.js": 787,
	"./partner/templates": 1723,
	"./partner/templates.js": 1723,
	"./partner/templates/email": 1724,
	"./partner/templates/email.js": 1724,
	"./partner/templates/email/filter": 788,
	"./partner/templates/email/filter.js": 788,
	"./partner/templates/email/table": 789,
	"./partner/templates/email/table.js": 789,
	"./partner/templates/email/template": 790,
	"./partner/templates/email/template.js": 790,
	"./partner/templates/emailTemplate": 1725,
	"./partner/templates/emailTemplate.js": 1725,
	"./partner/templates/pdf": 1726,
	"./partner/templates/pdf.js": 1726,
	"./partner/templates/pdf/filter": 791,
	"./partner/templates/pdf/filter.js": 791,
	"./partner/templates/pdf/table": 792,
	"./partner/templates/pdf/table.js": 792,
	"./partner/templates/pdf/template": 793,
	"./partner/templates/pdf/template.js": 793,
	"./partner/templates/pdfTemplate": 1727,
	"./partner/templates/pdfTemplate.js": 1727,
	"./partner/templates/sms": 1728,
	"./partner/templates/sms.js": 1728,
	"./partner/templates/sms/filter": 794,
	"./partner/templates/sms/filter.js": 794,
	"./partner/templates/sms/table": 795,
	"./partner/templates/sms/table.js": 795,
	"./partner/templates/sms/template": 796,
	"./partner/templates/sms/template.js": 796,
	"./partner/templates/smsTemplate": 1729,
	"./partner/templates/smsTemplate.js": 1729,
	"./partners": 1730,
	"./partners.js": 1730,
	"./partnersCategories": 1731,
	"./partnersCategories.js": 1731,
	"./partnersProducts": 1732,
	"./partnersProducts.js": 1732,
	"./partnersProductsCountry": 1733,
	"./partnersProductsCountry.js": 1733,
	"./partnersProviders": 1734,
	"./partnersProviders.js": 1734,
	"./partnersTypeProduct": 1735,
	"./partnersTypeProduct.js": 1735,
	"./payPrizesLoyalty": 1736,
	"./payPrizesLoyalty.js": 1736,
	"./payhistoryview": 1737,
	"./payhistoryview.js": 1737,
	"./platformSpecific": 1738,
	"./platformSpecific.js": 1738,
	"./platformSpecific2": 1739,
	"./platformSpecific2.js": 1739,
	"./playerAccount": 1740,
	"./playerAccount.js": 1740,
	"./playerAccount2": 1741,
	"./playerAccount2.js": 1741,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1742,
	"./playersList.js": 1742,
	"./playersList2": 1743,
	"./playersList2.js": 1743,
	"./playersListAggregator": 1744,
	"./playersListAggregator.js": 1744,
	"./playersLists": 1745,
	"./playersLists.js": 1745,
	"./playersReport": 1746,
	"./playersReport.js": 1746,
	"./pointSettings": 1747,
	"./pointSettings.js": 1747,
	"./pointsUsers": 1748,
	"./pointsUsers.js": 1748,
	"./pokerReport": 1749,
	"./pokerReport.js": 1749,
	"./prices": 1750,
	"./prices.js": 1750,
	"./prizesLoyalty": 1751,
	"./prizesLoyalty.js": 1751,
	"./products": 1752,
	"./products.js": 1752,
	"./products/banks/filterBanks": 319,
	"./products/banks/filterBanks.js": 319,
	"./products/banks/tableBanks": 320,
	"./products/banks/tableBanks.js": 320,
	"./products/blockchain-networks/filterBlockchainNetworks": 375,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 375,
	"./products/blockchain-networks/tableBlockchainNetworks": 376,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 376,
	"./products/categories-products/detailsCategoriesProducts": 1001,
	"./products/categories-products/detailsCategoriesProducts.js": 1001,
	"./products/categories-products/filterCategoriesProducts": 418,
	"./products/categories-products/filterCategoriesProducts.js": 418,
	"./products/categories-products/recordCategoriesProducts": 1002,
	"./products/categories-products/recordCategoriesProducts.js": 1002,
	"./products/categories-products/recordTableCategoriesProducts": 420,
	"./products/categories-products/recordTableCategoriesProducts.js": 420,
	"./products/categories-products/tableCategoriesProducts": 419,
	"./products/categories-products/tableCategoriesProducts.js": 419,
	"./products/categories/detailsCategories": 999,
	"./products/categories/detailsCategories.js": 999,
	"./products/categories/filterCategories": 415,
	"./products/categories/filterCategories.js": 415,
	"./products/categories/recordCategories": 1000,
	"./products/categories/recordCategories.js": 1000,
	"./products/categories/recordTableCategories": 417,
	"./products/categories/recordTableCategories.js": 417,
	"./products/categories/tableCategories": 416,
	"./products/categories/tableCategories.js": 416,
	"./products/crypto-blockchain/filterCryptoBlockchain": 440,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 440,
	"./products/crypto-blockchain/tableCryptoBlockchain": 441,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 441,
	"./products/cryptos/filterCrypto": 442,
	"./products/cryptos/filterCrypto.js": 442,
	"./products/cryptos/tableCrypto": 443,
	"./products/cryptos/tableCrypto.js": 443,
	"./products/franchises/filterFranchises": 505,
	"./products/franchises/filterFranchises.js": 505,
	"./products/franchises/tableFranchises": 506,
	"./products/franchises/tableFranchises.js": 506,
	"./products/partners-products-country/detailsPartnersProductsCountry": 807,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 807,
	"./products/partners-products-country/filterPartnersProductsCountry": 805,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 805,
	"./products/partners-products-country/recordPartnersProductsCountry": 808,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 808,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 809,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 809,
	"./products/partners-products-country/tablePartnersProductsCountry": 806,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 806,
	"./products/partners-products/detailsPartnersProducts": 803,
	"./products/partners-products/detailsPartnersProducts.js": 803,
	"./products/partners-products/filterPartnersProducts": 801,
	"./products/partners-products/filterPartnersProducts.js": 801,
	"./products/partners-products/recordPartnersProducts": 804,
	"./products/partners-products/recordPartnersProducts.js": 804,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 802,
	"./products/partners-products/tablePartnersProducts.js": 802,
	"./products/partners-providers/details": 812,
	"./products/partners-providers/details.js": 812,
	"./products/partners-providers/filter": 810,
	"./products/partners-providers/filter.js": 810,
	"./products/partners-providers/record": 813,
	"./products/partners-providers/record.js": 813,
	"./products/partners-providers/recordTable": 1753,
	"./products/partners-providers/recordTable.js": 1753,
	"./products/partners-providers/table": 811,
	"./products/partners-providers/table.js": 811,
	"./products/partners-tipoproducto/details": 816,
	"./products/partners-tipoproducto/details.js": 816,
	"./products/partners-tipoproducto/filter": 814,
	"./products/partners-tipoproducto/filter.js": 814,
	"./products/partners-tipoproducto/record": 817,
	"./products/partners-tipoproducto/record.js": 817,
	"./products/partners-tipoproducto/recordTable": 1754,
	"./products/partners-tipoproducto/recordTable.js": 1754,
	"./products/partners-tipoproducto/table": 815,
	"./products/partners-tipoproducto/table.js": 815,
	"./products/partners/filter": 797,
	"./products/partners/filter.js": 797,
	"./products/partners/table": 798,
	"./products/partners/table.js": 798,
	"./products/products/detailsProducts": 1018,
	"./products/products/detailsProducts.js": 1018,
	"./products/products/filterProducts": 839,
	"./products/products/filterProducts.js": 839,
	"./products/products/recordProducts": 1019,
	"./products/products/recordProducts.js": 1019,
	"./products/products/recordTableProducts": 841,
	"./products/products/recordTableProducts.js": 841,
	"./products/products/tableProducts": 840,
	"./products/products/tableProducts.js": 840,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 842,
	"./products/providers/filterProviders.js": 842,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 321,
	"./products/providers/recordTableProviders.js": 321,
	"./products/providers/tableProviders": 843,
	"./products/providers/tableProviders.js": 843,
	"./products/subProviders/filter": 844,
	"./products/subProviders/filter.js": 844,
	"./products/subProviders/table": 845,
	"./products/subProviders/table.js": 845,
	"./products/tags/detailsTags": 1020,
	"./products/tags/detailsTags.js": 1020,
	"./products/tags/filterTags": 846,
	"./products/tags/filterTags.js": 846,
	"./products/tags/recordTableTags": 847,
	"./products/tags/recordTableTags.js": 847,
	"./products/tags/recordTags": 1021,
	"./products/tags/recordTags.js": 1021,
	"./products/tags/tableTags": 848,
	"./products/tags/tableTags.js": 848,
	"./profile": 1755,
	"./profile.js": 1755,
	"./profileOptions": 1756,
	"./profileOptions.js": 1756,
	"./profileOptions2": 1757,
	"./profileOptions2.js": 1757,
	"./profileOptionsOld": 1758,
	"./profileOptionsOld.js": 1758,
	"./promotionalCasinoCampaings": 1759,
	"./promotionalCasinoCampaings.js": 1759,
	"./promotionalCodes": 1760,
	"./promotionalCodes.js": 1760,
	"./promotionalSportbookCampaings": 1761,
	"./promotionalSportbookCampaings.js": 1761,
	"./providers": 1762,
	"./providers.js": 1762,
	"./qualifying": 1763,
	"./qualifying.js": 1763,
	"./quotaRetraction": 1764,
	"./quotaRetraction.js": 1764,
	"./quotaRetractionReport": 1765,
	"./quotaRetractionReport.js": 1765,
	"./recargarCredito": 1766,
	"./recargarCredito.js": 1766,
	"./recargarCreditoAgente": 1767,
	"./recargarCreditoAgente.js": 1767,
	"./referralsAwardsReport": 1768,
	"./referralsAwardsReport.js": 1768,
	"./referralsReport": 1769,
	"./referralsReport.js": 1769,
	"./registerFast": 1770,
	"./registerFast.js": 1770,
	"./registeredDocument": 1771,
	"./registeredDocument.js": 1771,
	"./registeredDocuments": 1772,
	"./registeredDocuments.js": 1772,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 429,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 429,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 430,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 430,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 431,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 431,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 432,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 432,
	"./regulations/futureEvents/filterFutureEventsReports": 507,
	"./regulations/futureEvents/filterFutureEventsReports.js": 507,
	"./regulations/futureEvents/tableFutureEventsReports": 508,
	"./regulations/futureEvents/tableFutureEventsReports.js": 508,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 509,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 509,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 510,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 510,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 511,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 511,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 512,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 512,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 536,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 536,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 537,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 537,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 538,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 538,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 539,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 539,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 540,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 540,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 541,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 541,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 542,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 542,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 543,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 543,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 663,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 663,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 664,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 664,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 665,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 665,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 666,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 666,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 818,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 818,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 819,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 819,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 820,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 820,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 821,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 821,
	"./regulations/playerAccount/filterPlayerAccountReports": 822,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 822,
	"./regulations/playerAccount/tablePlayerAccountReports": 823,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 823,
	"./regulations/playerAccount2/filterPlayerAccountReports": 824,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 824,
	"./regulations/playerAccount2/tablePlayerAccountReports": 825,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 825,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 873,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 873,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 874,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 874,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 875,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 875,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 876,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 876,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 877,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 877,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 878,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 878,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 879,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 879,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 880,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 880,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 881,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 881,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 882,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 882,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 883,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 883,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 884,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 884,
	"./relationUserAggregator": 1773,
	"./relationUserAggregator.js": 1773,
	"./reportHash": 1774,
	"./reportHash.js": 1774,
	"./reportMarketing": 1775,
	"./reportMarketing.js": 1775,
	"./reports/affiliatesBetShop/filter": 205,
	"./reports/affiliatesBetShop/filter.js": 205,
	"./reports/affiliatesBetShop/table": 206,
	"./reports/affiliatesBetShop/table.js": 206,
	"./reports/assignmentQuota/filter": 290,
	"./reports/assignmentQuota/filter.js": 290,
	"./reports/assignmentQuota/table": 291,
	"./reports/assignmentQuota/table.js": 291,
	"./reports/assignmentQuotaMade/filter": 288,
	"./reports/assignmentQuotaMade/filter.js": 288,
	"./reports/assignmentQuotaMade/table": 289,
	"./reports/assignmentQuotaMade/table.js": 289,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 294,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 294,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 292,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 292,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 295,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 295,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 293,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 293,
	"./reports/balanceAdjustments/filter": 296,
	"./reports/balanceAdjustments/filter.js": 296,
	"./reports/balanceAdjustments/table": 297,
	"./reports/balanceAdjustments/table.js": 297,
	"./reports/balanceHistory/filter": 298,
	"./reports/balanceHistory/filter.js": 298,
	"./reports/balanceHistory/table": 299,
	"./reports/balanceHistory/table.js": 299,
	"./reports/balanceHistory2/filter": 1776,
	"./reports/balanceHistory2/filter.js": 1776,
	"./reports/balanceHistory2/filter2": 300,
	"./reports/balanceHistory2/filter2.js": 300,
	"./reports/balanceHistory2/table": 1777,
	"./reports/balanceHistory2/table.js": 1777,
	"./reports/balanceHistory2/table2": 301,
	"./reports/balanceHistory2/table2.js": 301,
	"./reports/balanceHistoryBetShop/filter": 304,
	"./reports/balanceHistoryBetShop/filter.js": 304,
	"./reports/balanceHistoryBetShop/table": 305,
	"./reports/balanceHistoryBetShop/table.js": 305,
	"./reports/balanceHistoryBetShop2/filter": 1778,
	"./reports/balanceHistoryBetShop2/filter.js": 1778,
	"./reports/balanceHistoryBetShop2/filter2": 306,
	"./reports/balanceHistoryBetShop2/filter2.js": 306,
	"./reports/balanceHistoryBetShop2/table": 1779,
	"./reports/balanceHistoryBetShop2/table.js": 1779,
	"./reports/balanceHistoryBetShop2/table2": 307,
	"./reports/balanceHistoryBetShop2/table2.js": 307,
	"./reports/balanceHistoryForAdminUser/filter": 302,
	"./reports/balanceHistoryForAdminUser/filter.js": 302,
	"./reports/balanceHistoryForAdminUser/table": 303,
	"./reports/balanceHistoryForAdminUser/table.js": 303,
	"./reports/balanceHistoryForAgent/filter": 308,
	"./reports/balanceHistoryForAgent/filter.js": 308,
	"./reports/balanceHistoryForAgent/table": 309,
	"./reports/balanceHistoryForAgent/table.js": 309,
	"./reports/balanceHistoryForBetShop/filter": 310,
	"./reports/balanceHistoryForBetShop/filter.js": 310,
	"./reports/balanceHistoryForBetShop/table": 311,
	"./reports/balanceHistoryForBetShop/table.js": 311,
	"./reports/balanceHistoryMachine/filter": 312,
	"./reports/balanceHistoryMachine/filter.js": 312,
	"./reports/balanceHistoryMachine/table": 313,
	"./reports/balanceHistoryMachine/table.js": 313,
	"./reports/balanceUsers/filter": 314,
	"./reports/balanceUsers/filter.js": 314,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 316,
	"./reports/balanceUsers/resume.js": 316,
	"./reports/balanceUsers/table": 315,
	"./reports/balanceUsers/table.js": 315,
	"./reports/betsReport/detailsReport": 1780,
	"./reports/betsReport/detailsReport.js": 1780,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1781,
	"./reports/betsReportBetShop/detailsReport.js": 1781,
	"./reports/betsReportBetShop/filterReport": 369,
	"./reports/betsReportBetShop/filterReport.js": 369,
	"./reports/betsReportBetShop/recordReport": 372,
	"./reports/betsReportBetShop/recordReport.js": 372,
	"./reports/betsReportBetShop/recordTableReport": 1782,
	"./reports/betsReportBetShop/recordTableReport.js": 1782,
	"./reports/betsReportBetShop/recordTableTransReport": 1783,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1783,
	"./reports/betsReportBetShop/recordTransReport": 371,
	"./reports/betsReportBetShop/recordTransReport.js": 371,
	"./reports/betsReportBetShop/tableReport": 370,
	"./reports/betsReportBetShop/tableReport.js": 370,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 377,
	"./reports/bonusReport/filterBonusReport.js": 377,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 378,
	"./reports/bonusReport/tableBonusReport.js": 378,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 379,
	"./reports/bonusReport2/filterBonusReport.js": 379,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1784,
	"./reports/bonusReport2/recordTableBonusReport.js": 1784,
	"./reports/bonusReport2/tableBonusReport": 380,
	"./reports/bonusReport2/tableBonusReport.js": 380,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 411,
	"./reports/casinoReport/filterCasinoReport.js": 411,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 412,
	"./reports/casinoReport/tableCasinoReport.js": 412,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1785,
	"./reports/casinoReport2/filterCasinoReport.js": 1785,
	"./reports/casinoReport2/filterCasinoReport2": 413,
	"./reports/casinoReport2/filterCasinoReport2.js": 413,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1786,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1786,
	"./reports/casinoReport2/tableCasinoReport": 1787,
	"./reports/casinoReport2/tableCasinoReport.js": 1787,
	"./reports/casinoReport2/tableCasinoReport2": 414,
	"./reports/casinoReport2/tableCasinoReport2.js": 414,
	"./reports/comissions_report/filter": 421,
	"./reports/comissions_report/filter.js": 421,
	"./reports/comissions_report/table": 422,
	"./reports/comissions_report/table.js": 422,
	"./reports/comissions_report2/filter": 423,
	"./reports/comissions_report2/filter.js": 423,
	"./reports/comissions_report2/table": 424,
	"./reports/comissions_report2/table.js": 424,
	"./reports/commisionsPay/filter": 425,
	"./reports/commisionsPay/filter.js": 425,
	"./reports/commisionsPay/table": 426,
	"./reports/commisionsPay/table.js": 426,
	"./reports/coupons_report/details": 1788,
	"./reports/coupons_report/details.js": 1788,
	"./reports/coupons_report/filter": 438,
	"./reports/coupons_report/filter.js": 438,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1789,
	"./reports/coupons_report/recordReports.js": 1789,
	"./reports/coupons_report/table": 439,
	"./reports/coupons_report/table.js": 439,
	"./reports/customReport/filter": 444,
	"./reports/customReport/filter.js": 444,
	"./reports/customReport/table": 445,
	"./reports/customReport/table.js": 445,
	"./reports/depositReport2/filter": 486,
	"./reports/depositReport2/filter.js": 486,
	"./reports/depositReport2/table": 487,
	"./reports/depositReport2/table.js": 487,
	"./reports/deposit_report/detailsDepositReports": 1006,
	"./reports/deposit_report/detailsDepositReports.js": 1006,
	"./reports/deposit_report/filterDepositReports": 484,
	"./reports/deposit_report/filterDepositReports.js": 484,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 485,
	"./reports/deposit_report/tableDepositReports.js": 485,
	"./reports/deposit_report_3/detailsDepositReports": 1007,
	"./reports/deposit_report_3/detailsDepositReports.js": 1007,
	"./reports/deposit_report_3/filterDepositReports": 488,
	"./reports/deposit_report_3/filterDepositReports.js": 488,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1790,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1790,
	"./reports/deposit_report_3/tableDepositReports": 489,
	"./reports/deposit_report_3/tableDepositReports.js": 489,
	"./reports/deposit_report_betshop/detailsDepositReports": 1008,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1008,
	"./reports/deposit_report_betshop/filterDepositReports": 490,
	"./reports/deposit_report_betshop/filterDepositReports.js": 490,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1791,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1791,
	"./reports/deposit_report_betshop/tableDepositReports": 491,
	"./reports/deposit_report_betshop/tableDepositReports.js": 491,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 499,
	"./reports/emailsReport/filterEmailsReport.js": 499,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1792,
	"./reports/emailsReport/recordTableEmailsReport.js": 1792,
	"./reports/emailsReport/tableEmailsReport": 500,
	"./reports/emailsReport/tableEmailsReport.js": 500,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 891,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 891,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 892,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 892,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 893,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 893,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 894,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 894,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 895,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 895,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1793,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1793,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 896,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 896,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 897,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 897,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1794,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1794,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1795,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1795,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 898,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 898,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 899,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 899,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 900,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 900,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 901,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 901,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1796,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1796,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 902,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 902,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 515,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 515,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 513,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 513,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 516,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 516,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 517,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 517,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 514,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 514,
	"./reports/historyMovement/filter": 518,
	"./reports/historyMovement/filter.js": 518,
	"./reports/historyMovement/table": 519,
	"./reports/historyMovement/table.js": 519,
	"./reports/historyMovementBetShop/filter": 520,
	"./reports/historyMovementBetShop/filter.js": 520,
	"./reports/historyMovementBetShop/table": 521,
	"./reports/historyMovementBetShop/table.js": 521,
	"./reports/historyPoints/filter": 522,
	"./reports/historyPoints/filter.js": 522,
	"./reports/historyPoints/table": 523,
	"./reports/historyPoints/table.js": 523,
	"./reports/informeCasino/detailsInformeCasino": 526,
	"./reports/informeCasino/detailsInformeCasino.js": 526,
	"./reports/informeCasino/filterInformeCasino": 524,
	"./reports/informeCasino/filterInformeCasino.js": 524,
	"./reports/informeCasino/recordInformeCasino": 527,
	"./reports/informeCasino/recordInformeCasino.js": 527,
	"./reports/informeCasino/recordTableInformeCasino": 1797,
	"./reports/informeCasino/recordTableInformeCasino.js": 1797,
	"./reports/informeCasino/tableInformeCasino": 525,
	"./reports/informeCasino/tableInformeCasino.js": 525,
	"./reports/informeGerencial/detailsInformeGerencial": 1798,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1798,
	"./reports/informeGerencial/filterInformeGerencial": 528,
	"./reports/informeGerencial/filterInformeGerencial.js": 528,
	"./reports/informeGerencial/recordInformeGerencial": 1799,
	"./reports/informeGerencial/recordInformeGerencial.js": 1799,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 529,
	"./reports/informeGerencial/tableInformeGerencial.js": 529,
	"./reports/informeGerencial2/detailsInformeGerencial": 1800,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1800,
	"./reports/informeGerencial2/filterInformeGerencial": 1801,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1801,
	"./reports/informeGerencial2/filterInformeGerencial2": 530,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 530,
	"./reports/informeGerencial2/recordInformeGerencial": 1802,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1802,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1803,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1803,
	"./reports/informeGerencial2/tableInformeGerencial": 1804,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1804,
	"./reports/informeGerencial2/tableInformeGerencial2": 531,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 531,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1805,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1805,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1806,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1806,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 532,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 532,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1807,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1807,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1808,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1808,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1809,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1809,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 533,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 533,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1810,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1810,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1811,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1811,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 534,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 534,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1812,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1812,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1813,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1813,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1814,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1814,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 535,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 535,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 544,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 544,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1815,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1815,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1816,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1816,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 545,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 545,
	"./reports/landingReport/detailsLandingReport": 548,
	"./reports/landingReport/detailsLandingReport.js": 548,
	"./reports/landingReport/filterLandingReport": 546,
	"./reports/landingReport/filterLandingReport.js": 546,
	"./reports/landingReport/recordLandingReport": 549,
	"./reports/landingReport/recordLandingReport.js": 549,
	"./reports/landingReport/recordTableLandingReport": 1817,
	"./reports/landingReport/recordTableLandingReport.js": 1817,
	"./reports/landingReport/tableLandingReport": 547,
	"./reports/landingReport/tableLandingReport.js": 547,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 550,
	"./reports/landingReport2/filterLandingReport.js": 550,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1818,
	"./reports/landingReport2/recordTableLandingReport.js": 1818,
	"./reports/landingReport2/tableLandingReport": 551,
	"./reports/landingReport2/tableLandingReport.js": 551,
	"./reports/limitationsReport/filterDepositReports": 568,
	"./reports/limitationsReport/filterDepositReports.js": 568,
	"./reports/limitationsReport/tableDepositReports": 569,
	"./reports/limitationsReport/tableDepositReports.js": 569,
	"./reports/logsUser/filter": 572,
	"./reports/logsUser/filter.js": 572,
	"./reports/logsUser/table": 573,
	"./reports/logsUser/table.js": 573,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 574,
	"./reports/loteryReport/filterLoteryReport.js": 574,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1819,
	"./reports/loteryReport/recordTableLoteryReport.js": 1819,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/my_comissions_report/filter": 657,
	"./reports/my_comissions_report/filter.js": 657,
	"./reports/my_comissions_report/table": 658,
	"./reports/my_comissions_report/table.js": 658,
	"./reports/notesUser/filter": 659,
	"./reports/notesUser/filter.js": 659,
	"./reports/notesUser/table": 660,
	"./reports/notesUser/table.js": 660,
	"./reports/operatorResponsibility/filter": 661,
	"./reports/operatorResponsibility/filter.js": 661,
	"./reports/operatorResponsibility/table": 662,
	"./reports/operatorResponsibility/table.js": 662,
	"./reports/partners-categories/filter": 799,
	"./reports/partners-categories/filter.js": 799,
	"./reports/partners-categories/table": 800,
	"./reports/partners-categories/table.js": 800,
	"./reports/playersReport/detailsPlayersReport": 828,
	"./reports/playersReport/detailsPlayersReport.js": 828,
	"./reports/playersReport/filterPlayersReport": 826,
	"./reports/playersReport/filterPlayersReport.js": 826,
	"./reports/playersReport/recordPlayersReport": 829,
	"./reports/playersReport/recordPlayersReport.js": 829,
	"./reports/playersReport/recordTablePlayersReport": 830,
	"./reports/playersReport/recordTablePlayersReport.js": 830,
	"./reports/playersReport/tablePlayersReport": 827,
	"./reports/playersReport/tablePlayersReport.js": 827,
	"./reports/pointSettings/filter": 831,
	"./reports/pointSettings/filter.js": 831,
	"./reports/pointSettings/table": 832,
	"./reports/pointSettings/table.js": 832,
	"./reports/pointsUsers/filter": 833,
	"./reports/pointsUsers/filter.js": 833,
	"./reports/pointsUsers/table": 834,
	"./reports/pointsUsers/table.js": 834,
	"./reports/pokerReport/filterCasinoReport": 835,
	"./reports/pokerReport/filterCasinoReport.js": 835,
	"./reports/pokerReport/tableCasinoReport": 836,
	"./reports/pokerReport/tableCasinoReport.js": 836,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1820,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1820,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 667,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 667,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1821,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1821,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 903,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 903,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 668,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 668,
	"./reports/prizesLoyalty/filter": 837,
	"./reports/prizesLoyalty/filter.js": 837,
	"./reports/prizesLoyalty/table": 838,
	"./reports/prizesLoyalty/table.js": 838,
	"./reports/promotionalCasinoCampaings/filter": 854,
	"./reports/promotionalCasinoCampaings/filter.js": 854,
	"./reports/promotionalCasinoCampaings/table": 855,
	"./reports/promotionalCasinoCampaings/table.js": 855,
	"./reports/promotionalCodes/filter": 856,
	"./reports/promotionalCodes/filter.js": 856,
	"./reports/promotionalCodes/table": 857,
	"./reports/promotionalCodes/table.js": 857,
	"./reports/promotionalSpoortbookCampaings/filter": 858,
	"./reports/promotionalSpoortbookCampaings/filter.js": 858,
	"./reports/promotionalSpoortbookCampaings/table": 859,
	"./reports/promotionalSpoortbookCampaings/table.js": 859,
	"./reports/quotaRetraction/filter": 862,
	"./reports/quotaRetraction/filter.js": 862,
	"./reports/quotaRetraction/table": 863,
	"./reports/quotaRetraction/table.js": 863,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 864,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 864,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1822,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1822,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1823,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1823,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 865,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 865,
	"./reports/referralsReport/filterReferralsReports": 866,
	"./reports/referralsReport/filterReferralsReports.js": 866,
	"./reports/referralsReport/recordReferralsReports": 1824,
	"./reports/referralsReport/recordReferralsReports.js": 1824,
	"./reports/referralsReport/recordTableReferralsReports": 1825,
	"./reports/referralsReport/recordTableReferralsReports.js": 1825,
	"./reports/referralsReport/tableReferralsReports": 867,
	"./reports/referralsReport/tableReferralsReports.js": 867,
	"./reports/registeredDocuments/filter": 868,
	"./reports/registeredDocuments/filter.js": 868,
	"./reports/registeredDocuments/record": 163,
	"./reports/registeredDocuments/record.js": 163,
	"./reports/registeredDocuments/recordTable": 870,
	"./reports/registeredDocuments/recordTable.js": 870,
	"./reports/registeredDocuments/table": 869,
	"./reports/registeredDocuments/table.js": 869,
	"./reports/relationUserAggregator/filter": 885,
	"./reports/relationUserAggregator/filter.js": 885,
	"./reports/relationUserAggregator/table": 886,
	"./reports/relationUserAggregator/table.js": 886,
	"./reports/reportHash/filter": 887,
	"./reports/reportHash/filter.js": 887,
	"./reports/reportHash/table": 888,
	"./reports/reportHash/table.js": 888,
	"./reports/reportMarketing/filter": 889,
	"./reports/reportMarketing/filter.js": 889,
	"./reports/reportMarketing/table": 890,
	"./reports/reportMarketing/table.js": 890,
	"./reports/rouletteReport/filter": 904,
	"./reports/rouletteReport/filter.js": 904,
	"./reports/rouletteReport/table": 905,
	"./reports/rouletteReport/table.js": 905,
	"./reports/sessionsReport/detailsSessionsReport": 906,
	"./reports/sessionsReport/detailsSessionsReport.js": 906,
	"./reports/sessionsReport/filterSessionsReport": 907,
	"./reports/sessionsReport/filterSessionsReport.js": 907,
	"./reports/sessionsReport/recordSessionsReport": 1022,
	"./reports/sessionsReport/recordSessionsReport.js": 1022,
	"./reports/sessionsReport/recordTableSessionsReport": 1023,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1023,
	"./reports/sessionsReport/tableSessionsReport": 908,
	"./reports/sessionsReport/tableSessionsReport.js": 908,
	"./reports/sessionsReport2/filter": 909,
	"./reports/sessionsReport2/filter.js": 909,
	"./reports/sessionsReport2/table": 910,
	"./reports/sessionsReport2/table.js": 910,
	"./reports/sportsPoolReport/filterReport": 911,
	"./reports/sportsPoolReport/filterReport.js": 911,
	"./reports/sportsPoolReport/tableReport": 912,
	"./reports/sportsPoolReport/tableReport.js": 912,
	"./reports/sportsTransactions/filter": 913,
	"./reports/sportsTransactions/filter.js": 913,
	"./reports/sportsTransactions/table": 914,
	"./reports/sportsTransactions/table.js": 914,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 915,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 915,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 916,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 916,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 917,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 917,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1826,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1826,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 918,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 918,
	"./reports/taxPaymentsReport/filter": 919,
	"./reports/taxPaymentsReport/filter.js": 919,
	"./reports/taxPaymentsReport/table": 920,
	"./reports/taxPaymentsReport/table.js": 920,
	"./reports/taxableEarnings/filter": 921,
	"./reports/taxableEarnings/filter.js": 921,
	"./reports/taxableEarnings/table": 922,
	"./reports/taxableEarnings/table.js": 922,
	"./reports/transactionReport/filter": 923,
	"./reports/transactionReport/filter.js": 923,
	"./reports/transactionReport/table": 924,
	"./reports/transactionReport/table.js": 924,
	"./reports/transfersReport/filter": 925,
	"./reports/transfersReport/filter.js": 925,
	"./reports/transfersReport/table": 926,
	"./reports/transfersReport/table.js": 926,
	"./reports/userAffiliatesAgent/filter": 927,
	"./reports/userAffiliatesAgent/filter.js": 927,
	"./reports/userAffiliatesAgent/table": 928,
	"./reports/userAffiliatesAgent/table.js": 928,
	"./reports/userAffiliatesBetShop/filter": 929,
	"./reports/userAffiliatesBetShop/filter.js": 929,
	"./reports/userAffiliatesBetShop/table": 930,
	"./reports/userAffiliatesBetShop/table.js": 930,
	"./reports/usuarioOnlineResumido/filter": 931,
	"./reports/usuarioOnlineResumido/filter.js": 931,
	"./reports/usuarioOnlineResumido/table": 932,
	"./reports/usuarioOnlineResumido/table.js": 932,
	"./reports/withdrawalReport2/filter": 933,
	"./reports/withdrawalReport2/filter.js": 933,
	"./reports/withdrawalReport2/table": 934,
	"./reports/withdrawalReport2/table.js": 934,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 935,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 935,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 936,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 936,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1827,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1827,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 937,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 937,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 938,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 938,
	"./reports/withdrawalRequestsComissions/filter": 939,
	"./reports/withdrawalRequestsComissions/filter.js": 939,
	"./reports/withdrawalRequestsComissions/table": 940,
	"./reports/withdrawalRequestsComissions/table.js": 940,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 164,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 164,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 941,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 941,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 942,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 942,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 943,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 943,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1828,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1828,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 944,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 944,
	"./reprintCheck": 1829,
	"./reprintCheck.js": 1829,
	"./requests/registration-requests/filter": 945,
	"./requests/registration-requests/filter.js": 945,
	"./requests/registration-requests/generateRequests": 946,
	"./requests/registration-requests/generateRequests.js": 946,
	"./requests/registration-requests/recordTableResponts": 947,
	"./requests/registration-requests/recordTableResponts.js": 947,
	"./requests/registration-requests/table": 949,
	"./requests/registration-requests/table.js": 949,
	"./requests/registration-requests/tableResponts": 948,
	"./requests/registration-requests/tableResponts.js": 948,
	"./requests/registrationRequests": 1830,
	"./requests/registrationRequests.js": 1830,
	"./resources-locale_es.json": 1932,
	"./restrictUser": 1831,
	"./restrictUser.js": 1831,
	"./reversionReload": 1832,
	"./reversionReload.js": 1832,
	"./rouletteReport": 1833,
	"./rouletteReport.js": 1833,
	"./security/adminuser/addAdminUser": 1834,
	"./security/adminuser/addAdminUser.js": 1834,
	"./security/adminuser/configuration/changePassword": 1835,
	"./security/adminuser/configuration/changePassword.js": 1835,
	"./security/adminuser/configuration/changePassword/changePasswordView": 950,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 950,
	"./security/adminuser/configuration/generateToken": 1836,
	"./security/adminuser/configuration/generateToken.js": 1836,
	"./security/adminuser/configuration/generateToken/filter": 951,
	"./security/adminuser/configuration/generateToken/filter.js": 951,
	"./security/adminuser/configuration/generateToken/table": 952,
	"./security/adminuser/configuration/generateToken/table.js": 952,
	"./security/adminuser/configuration/qrgoogle": 1837,
	"./security/adminuser/configuration/qrgoogle.js": 1837,
	"./security/adminuser/configuration/securityChanges": 1838,
	"./security/adminuser/configuration/securityChanges.js": 1838,
	"./security/adminuser/configuration/securityChanges/filter": 170,
	"./security/adminuser/configuration/securityChanges/filter.js": 170,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1839,
	"./security/adminuser/configurationAdminUser.js": 1839,
	"./security/adminuser/detailsAdminUser": 1840,
	"./security/adminuser/detailsAdminUser.js": 1840,
	"./security/adminuser/filterAdminUser": 203,
	"./security/adminuser/filterAdminUser.js": 203,
	"./security/adminuser/informationAdminUser": 1841,
	"./security/adminuser/informationAdminUser.js": 1841,
	"./security/adminuser/recordAdminUser": 1842,
	"./security/adminuser/recordAdminUser.js": 1842,
	"./security/adminuser/recordTableAdminUser": 953,
	"./security/adminuser/recordTableAdminUser.js": 953,
	"./security/adminuser/reports/logsUser": 1843,
	"./security/adminuser/reports/logsUser.js": 1843,
	"./security/adminuser/reports/logsUser/filter": 954,
	"./security/adminuser/reports/logsUser/filter.js": 954,
	"./security/adminuser/reports/logsUser/table": 955,
	"./security/adminuser/reports/logsUser/table.js": 955,
	"./security/adminuser/reportsAdminUser": 1844,
	"./security/adminuser/reportsAdminUser.js": 1844,
	"./security/adminuser/tableAdminUser": 204,
	"./security/adminuser/tableAdminUser.js": 204,
	"./security/approvalLogs/filter": 282,
	"./security/approvalLogs/filter.js": 282,
	"./security/approvalLogs/table": 283,
	"./security/approvalLogs/table.js": 283,
	"./security/approvalLogs2/filter": 284,
	"./security/approvalLogs2/filter.js": 284,
	"./security/approvalLogs2/table": 285,
	"./security/approvalLogs2/table.js": 285,
	"./security/approvalLogsBetShop/filter": 286,
	"./security/approvalLogsBetShop/filter.js": 286,
	"./security/approvalLogsBetShop/table": 287,
	"./security/approvalLogsBetShop/table.js": 287,
	"./security/contingencia/detailsContingencia": 1845,
	"./security/contingencia/detailsContingencia.js": 1845,
	"./security/contingencia/filterContingencia": 433,
	"./security/contingencia/filterContingencia.js": 433,
	"./security/contingencia/recordContingencia": 1846,
	"./security/contingencia/recordContingencia.js": 1846,
	"./security/contingencia/recordTableContingencia": 956,
	"./security/contingencia/recordTableContingencia.js": 956,
	"./security/contingencia/tableContingencia": 434,
	"./security/contingencia/tableContingencia.js": 434,
	"./security/menu/filter": 647,
	"./security/menu/filter.js": 647,
	"./security/menu/table": 648,
	"./security/menu/table.js": 648,
	"./security/perfil/detailsPerfil": 851,
	"./security/perfil/detailsPerfil.js": 851,
	"./security/perfil/filterPerfil": 849,
	"./security/perfil/filterPerfil.js": 849,
	"./security/perfil/recordPerfil": 852,
	"./security/perfil/recordPerfil.js": 852,
	"./security/perfil/recordTablePerfil": 853,
	"./security/perfil/recordTablePerfil.js": 853,
	"./security/perfil/tablePerfil": 850,
	"./security/perfil/tablePerfil.js": 850,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1847,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1847,
	"./security/perfilopciones2/filterPerfilOpciones": 1848,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1848,
	"./security/perfilopciones2/recordPerfilOpciones": 1849,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1849,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1850,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1850,
	"./security/perfilopciones2/tablePerfilOpciones": 1851,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1851,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1852,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1852,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1853,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1853,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1854,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1854,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1855,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1855,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1856,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1856,
	"./security/submenu/detailsSubMenu": 957,
	"./security/submenu/detailsSubMenu.js": 957,
	"./security/submenu/filterSubMenu": 958,
	"./security/submenu/filterSubMenu.js": 958,
	"./security/submenu/recordSubMenu": 959,
	"./security/submenu/recordSubMenu.js": 959,
	"./security/submenu/recordTableSubMenu": 960,
	"./security/submenu/recordTableSubMenu.js": 960,
	"./security/submenu/tableSubMenu": 961,
	"./security/submenu/tableSubMenu.js": 961,
	"./security/totalContingencies/table": 962,
	"./security/totalContingencies/table.js": 962,
	"./security/userSitebuilder/filter": 963,
	"./security/userSitebuilder/filter.js": 963,
	"./security/userSitebuilder/information": 1857,
	"./security/userSitebuilder/information.js": 1857,
	"./security/userSitebuilder/table": 964,
	"./security/userSitebuilder/table.js": 964,
	"./security/userVerification2/filter": 965,
	"./security/userVerification2/filter.js": 965,
	"./security/userVerification2/information": 1858,
	"./security/userVerification2/information.js": 1858,
	"./security/userVerification2/table": 966,
	"./security/userVerification2/table.js": 966,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1859,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1859,
	"./security/usuarioperfil/filterUsuarioPerfil": 967,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 967,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 968,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 968,
	"./security/usuarioperfil/recordUsuarioPerfil": 1860,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1860,
	"./security/usuarioperfil/tableUsuarioPerfil": 969,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 969,
	"./security/usuariosbloqueados/add": 1861,
	"./security/usuariosbloqueados/add.js": 1861,
	"./security/usuariosbloqueados/filter": 970,
	"./security/usuariosbloqueados/filter.js": 970,
	"./security/usuariosbloqueados/table": 971,
	"./security/usuariosbloqueados/table.js": 971,
	"./security/wallets/filter": 972,
	"./security/wallets/filter.js": 972,
	"./security/wallets/table": 973,
	"./security/wallets/table.js": 973,
	"./sessionsReport": 1862,
	"./sessionsReport.js": 1862,
	"./sessionsReport2": 1863,
	"./sessionsReport2.js": 1863,
	"./settings": 1864,
	"./settings.js": 1864,
	"./significantEventsAndAlterations": 1865,
	"./significantEventsAndAlterations.js": 1865,
	"./significantEventsAndAlterations2": 1866,
	"./significantEventsAndAlterations2.js": 1866,
	"./sportsPoolReport": 1867,
	"./sportsPoolReport.js": 1867,
	"./sportsTransactions": 1868,
	"./sportsTransactions.js": 1868,
	"./subMenu": 1869,
	"./subMenu.js": 1869,
	"./subProviders": 1870,
	"./subProviders.js": 1870,
	"./summaryBetsReport": 1871,
	"./summaryBetsReport.js": 1871,
	"./summaryCashFlow": 1872,
	"./summaryCashFlow.js": 1872,
	"./summaryCashFlow2": 1873,
	"./summaryCashFlow2.js": 1873,
	"./summaryCashFlowMachine": 1874,
	"./summaryCashFlowMachine.js": 1874,
	"./tags": 1875,
	"./tags.js": 1875,
	"./taxPaymentsReport": 1876,
	"./taxPaymentsReport.js": 1876,
	"./taxableEarnings": 1877,
	"./taxableEarnings.js": 1877,
	"./teacher/concessionaire/filterConcessionaire": 503,
	"./teacher/concessionaire/filterConcessionaire.js": 503,
	"./teacher/concessionaire/tableConcessionaire": 504,
	"./teacher/concessionaire/tableConcessionaire.js": 504,
	"./teacher/qualifying/filterQualifying": 860,
	"./teacher/qualifying/filterQualifying.js": 860,
	"./teacher/qualifying/tableQualifying": 861,
	"./teacher/qualifying/tableQualifying.js": 861,
	"./teacher/registered-documents/filterRegisteredDocuments": 871,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 871,
	"./teacher/registered-documents/tableRegisteredDocuments": 872,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 872,
	"./termsAndConditions": 1878,
	"./termsAndConditions.js": 1878,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 435,
	"./tools/countries/filter.js": 435,
	"./tools/countries/table": 436,
	"./tools/countries/table.js": 436,
	"./tools/translationManager": 1879,
	"./tools/translationManager.js": 1879,
	"./tools/translationManager/filter": 974,
	"./tools/translationManager/filter.js": 974,
	"./tools/translationManager/table": 975,
	"./tools/translationManager/table.js": 975,
	"./tools/uploadImage": 1880,
	"./tools/uploadImage.js": 1880,
	"./top": 1881,
	"./top.js": 1881,
	"./totalContingencies": 1882,
	"./totalContingencies.js": 1882,
	"./transactionReport": 1883,
	"./transactionReport.js": 1883,
	"./transactions": 1884,
	"./transactions.js": 1884,
	"./transactionsByPlayer": 1885,
	"./transactionsByPlayer.js": 1885,
	"./transactionsByPlayerDeposit": 1886,
	"./transactionsByPlayerDeposit.js": 1886,
	"./transactionsByPlayerFirstLevel": 1887,
	"./transactionsByPlayerFirstLevel.js": 1887,
	"./transactionsByPlayerSecondLevel": 1888,
	"./transactionsByPlayerSecondLevel.js": 1888,
	"./trasnfersReport": 1889,
	"./trasnfersReport.js": 1889,
	"./tutorials": 1890,
	"./tutorials.js": 1890,
	"./userAffiliatesAgent": 1891,
	"./userAffiliatesAgent.js": 1891,
	"./userAffiliatesBetShop": 1892,
	"./userAffiliatesBetShop.js": 1892,
	"./userManagement": 1893,
	"./userManagement.js": 1893,
	"./userManagement/userManagement/detailsUserManagement": 978,
	"./userManagement/userManagement/detailsUserManagement.js": 978,
	"./userManagement/userManagement/filterUserManagement": 976,
	"./userManagement/userManagement/filterUserManagement.js": 976,
	"./userManagement/userManagement/recordTableUserManagement": 980,
	"./userManagement/userManagement/recordTableUserManagement.js": 980,
	"./userManagement/userManagement/recordUserManagement": 979,
	"./userManagement/userManagement/recordUserManagement.js": 979,
	"./userManagement/userManagement/tableUserManagement": 977,
	"./userManagement/userManagement/tableUserManagement.js": 977,
	"./userProfile": 1894,
	"./userProfile.js": 1894,
	"./usersSitebuilder": 1895,
	"./usersSitebuilder.js": 1895,
	"./usersVerification": 1896,
	"./usersVerification.js": 1896,
	"./usersVerification/information": 981,
	"./usersVerification/information.js": 981,
	"./usersVerification2": 1897,
	"./usersVerification2.js": 1897,
	"./usersVerificationManagement": 1898,
	"./usersVerificationManagement.js": 1898,
	"./usuarioOnlineResumido": 1899,
	"./usuarioOnlineResumido.js": 1899,
	"./usuariosbloqueados": 1900,
	"./usuariosbloqueados.js": 1900,
	"./verifyAccount": 1901,
	"./verifyAccount.js": 1901,
	"./verifyAccountAgent": 1902,
	"./verifyAccountAgent.js": 1902,
	"./verifyAccountJumio": 1903,
	"./verifyAccountJumio.js": 1903,
	"./wallets": 1904,
	"./wallets.js": 1904,
	"./watchListReport": 1905,
	"./watchListReport.js": 1905,
	"./watchListReport/filterReport": 982,
	"./watchListReport/filterReport.js": 982,
	"./watchListReport/tableReport": 983,
	"./watchListReport/tableReport.js": 983,
	"./widgets": 1906,
	"./widgets.js": 1906,
	"./withdrawal": 1907,
	"./withdrawal.js": 1907,
	"./withdrawalReport2": 1908,
	"./withdrawalReport2.js": 1908,
	"./withdrawalRequests": 1909,
	"./withdrawalRequests.js": 1909,
	"./withdrawalRequestsBetShop": 1910,
	"./withdrawalRequestsBetShop.js": 1910,
	"./withdrawalRequestsComissions": 1911,
	"./withdrawalRequestsComissions.js": 1911,
	"./withdrawalRequestsForBetShop": 1912,
	"./withdrawalRequestsForBetShop.js": 1912,
	"./withdrawalRequestsForBetShop2": 1913,
	"./withdrawalRequestsForBetShop2.js": 1913,
	"./withdrawalRequestsRetail": 1914,
	"./withdrawalRequestsRetail.js": 1914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1924;